<template >
    <div v-if="spinner==true" class="spinner"></div>
    <div :class="spinner == true?'difuminado':''">
        <div class="card">
            <div class="card-header">
                <p class="card-title"> Albaranes</p>
            </div>
            <div class="card-body">
                    <div class="row"> 
                        <div class="col-md-4">
                            <label for="">Empresa</label>
                            <select v-model="empresaselec" class="form-control form-control-sm" name="" id="empr">
                                <option :key="''" :value="''">Todas</option>
                                <option v-for="empr in empresas" :key="empr.id" :value="empr.id">{{ empr.nombre_empresa }}</option>
                            </select>
                        </div>    
                        <div class="col-md-4">
                            <label for="">Compañía</label><br>
                            <MultiSelect v-if="companiasCargadas" style="padding:0%;" v-model="companiasSeleccionadas" optionLabel="nombre" :options="companias" filter
                                :maxSelectedLabels="1" class="selector-filtro" placeholder="Seleccione compañía">
                                <template #option="slotProps">
                                    {{ slotProps.option.nombre }}({{slotProps.option.prefijo}})
                                </template>
                            </MultiSelect>
                        </div>    
                        <div class="col-md-4 row" style="gap: 30px;">
                            <div>
                                <label for="">Fecha inicio</label>
                                <input class="form-control form-control-sm" type="date" v-model="fecha_inicio">
                            </div>
                            <div>
                                <label for="">Fecha fin</label>
                                <input class="form-control form-control-sm" type="date" v-model="fecha_fin">
                            </div>
                        </div>                               
                    </div>
            </div>
        </div>
        <div class="card card-default card-tabs">
            <div class="card-header p-1 pt-1">
                <ul class="nav nav-pills" ref="tabHeaders">
                    <li  class="nav-item">
                        <a class="nav-link active" href="#busqueda" data-toggle="tab">
                            Búsqueda
                        </a>
                    </li>
                    <li  class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#expedientes">
                            Números expedientes
                        </a>
                    </li>
                    <li v-if="mostrarCSV" class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#importcsv">
                            Importación CSV
                        </a>
                    </li>
                    <li v-if="mostrarCSVLD"  class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#importcsvld">
                            Importación CSV LD
                        </a>
                    </li>
                    <li v-if="mostrarPDF"  class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#importpdf">
                            Importación PDF
                        </a>
                    </li>
                </ul>
            </div>
            <div class="card-body" style="padding: 0px;">
                <div class="tab-content" ref="tabContents">
                    <div class="tab-pane active container-grid" id="busqueda">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">
                                        Número Albarán
                                    </th>
                                    <th style="text-align: center;">
                                        Facturado
                                    </th>
                                    <th style="text-align: center;">
                                        Búsqueda Nombre
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="text-align: center;">
                                        <input v-model="numeroAlbaran" class="form-control form-control-sm" type="text">
                                    </td>
                                    <td style="text-align: center;">
                                        <select class="form-control form-control-sm" v-model="facturadoselec" id="">
                                            <option value="">Todos</option>
                                            <option value="SI">SI</option>
                                            <option value="NO">NO</option>
                                        </select>
                                    </td>
                                    <td  style="text-align: center;">
                                        <input class="form-control form-control-sm" v-model="busquedaNombre" type="text">
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="display: flex; justify-content: center; gap: 10px; margin-bottom: 15px;">
                            <button @click="mostrarAlbaranesBusqueda" class="btn btn-sm btn-primary">Mostrar</button>
                            <button @click="exportarCSVAlbaranesBusqueda" class="btn btn-sm btn-primary">Exportar CSV</button>
                        </div>
                    </div>
                    <div class="tab-pane container-grid" id="expedientes">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">
                                        Número de expedientes (separados por comas)
                                    </th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="display: flex;justify-content: center; gap: 20px;">
                                        <textarea style="width: 50%;" class="form-control form-control-sm" v-model="numerosExpedientes"> </textarea>
                                        <div v-if="mostrarrelacionados" class="row" style="align-items: center; gap: 5px;">
                                            <label style="margin: 0;" for="">Incluir relacionados</label>
                                            <input type="checkbox" v-model="incluirelacionados">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="display: flex; justify-content: center; gap: 10px; ; margin-bottom: 15px;">
                            <button @click="mostrarAlbaranesNumerosExpe" class="btn btn-sm btn-primary">Mostrar</button>
                            <button @click="exportarCSVAlbaranesNumerosExpe" class="btn btn-sm btn-primary">Exportar CSV</button>
                        </div>
                    </div>
                    <div class="tab-pane container-grid" id="importcsv">
                        <div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-align: center;">Formato CSV</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="row">
                                            <div class="col-md-3">
                                                <img src="@/assets/img/ejemplo_importacion_albaranes_csv.png" alt="" width="400px">
                                            </div>
                                            <div class="col-md-5">
                                                <div>
                                                    <p>El CSV debe contener las siguientes columnas, separadas por punto y coma (;), por este orden:</p>
                                                    <ul>
                                                        <li><small>ENCARGO</small></li>
                                                        <li><small>Fecha Factura (formato: dd/mm/aaaa)</small></li>
                                                        <li><small>Número Factura (opcional. Si vacío, cogerá el siguiente de su línea de facturación) (no poner prefijo/sufijo)</small></li>
                                                        <li><small>Importe factura (con IVA)</small></li>
                                                        <li><small>Cobrado (SI/NO) (vacío implica NO)</small></li>
                                                        <li><small>Fecha cobro</small></li>
                                                        <li><small>Cliente: A (Asegurado), C (Compañía), vacío se factura como en el albarán</small></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="">Serie de numeración</label>
                                                        <select style="width: 150px;" class="form-control form-control-sm" v-model="serieCSVseleccionada" id="">
                                                            <option value="">Seleccione serie</option>
                                                            <option v-for="serie in series" :key="serie.id" :value="serie.id">{{ serie.nombre_serie }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-5">
                                                        <label for="">Fichero de importación CSV</label>
                                                        <FileUpload mode="basic" :maxFileSize="20000000" @select="subirarchivo($event)" chooseLabel="Elegir Archivo" class="btn btn-sm btn-primary"/>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <span v-if="mostraravisos">
                                                            <label for="">Incluir avisos</label><br>
                                                            <input type="checkbox" v-model="incluiravisoscsv">
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="display: flex; justify-content: center; gap: 10px; margin-bottom: 15px;">
                                <button @click="mostrarAlbaranesCSV" class="btn btn-sm btn-primary">Mostrar</button>
                                <button @click="exportarCSVAlbaranesCSV" class="btn btn-sm btn-primary">Exportar CSV</button>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane container-grid" id="importcsvld">
                        
                        <div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="text-align: center;">Formato CSV-LD</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="row">
                                            <div class="col-md-3">
                                                <img src="@/assets/img/ejemplo_importacion_albaranes_csv.png" alt="" width="400px">
                                            </div>
                                            <div class="col-md-5">
                                                <div>
                                                    <p>El CSV debe contener las siguientes columnas, separadas por punto y coma (;), por este orden:</p>
                                                    <ul>
                                                        <li><small>ENCARGO</small></li>
                                                        <li><small>Fecha Factura (formato: dd/mm/aaaa)</small></li>
                                                        <li><small>Número Factura (opcional. Si vacío, cogerá el siguiente de su línea de facturación) (no poner prefijo/sufijo)</small></li>
                                                        <li><small>Importe factura (con IVA)</small></li>
                                                        <li><small>Cobrado (SI/NO) (vacío implica NO)</small></li>
                                                        <li><small>Fecha cobro</small></li>
                                                        <li><small>Cliente: A (Asegurado), C (Compañía), vacío se factura como en el albarán</small></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <label for="">Serie de numeración</label>
                                                        <select style="width: 150px;" class="form-control form-control-sm" v-model="serieCSVLDseleccionada" id="">
                                                            <option value="">Seleccione serie</option>
                                                            <option v-for="serie in series" :key="serie.id" :value="serie.id">{{ serie.nombre_serie }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-5">
                                                        <label for="">Fichero de importación CSV</label>
                                                        <FileUpload mode="basic" :maxFileSize="20000000" @select="subirarchivo($event)" chooseLabel="Elegir Archivo" class="btn btn-sm btn-primary"/>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <span v-if="mostraravisos">
                                                            <label for="">Incluir avisos</label><br>
                                                            <input type="checkbox" v-model="incluiravisoscsvld">
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style="display: flex; justify-content: center; gap: 10px; margin-bottom: 15px;">
                                <button @click="mostrarAlbaranesCSVLD" class="btn btn-sm btn-primary">Mostrar</button>
                                <button @click="exportarCSVAlbaranesCSVLD" class="btn btn-sm btn-primary">Exportar CSV</button>
                            </div>
                        </div>
                    
                    </div>
                    <div class="tab-pane container-grid" id="importpdf">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">
                                        Importar expedientes desde el PDF
                                    </th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="display: flex;justify-content: center; gap: 20px;">
                                        <FileUpload mode="basic" :maxFileSize="20000000" @select="subirarchivoPdf($event)" chooseLabel="Elegir Archivo" class="btn btn-sm btn-primary"/>
                                        <div v-if="mostrarrelacionados" class="row" style="align-items: center; gap: 5px;">
                                            <label style="margin: 0;" for="">Incluir relacionados</label>
                                            <input type="checkbox" v-model="incluirelacionadospdf">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="display: flex; justify-content: center; gap:10px; margin-bottom: 15px;">
                            <button @click="mostrarAlbaranesPDF" class="btn btn-sm btn-primary">Mostrar</button>
                            <button @click="exportarCSVAlbaranesPDF" class="btn btn-sm btn-primary">Exportar CSV</button>
                        </div>
                    </div>                
                </div>            
            </div>
        </div>
        <div class="card" v-if="albaranesVisibles">
            <div class="card-body" style="padding: 0px;">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th style="text-align: center;">Nº Albarán</th>
                            <th style="text-align: center;">Fecha Albarán</th>
                            <th style="text-align: center;">Expediente</th>
                            <th style="text-align: center;">Cliente</th>
                            <th style="text-align: center;">Importe</th>
                            <th style="text-align: center;">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Registro' : 'Factura'  }}</th>
                            <th style="text-align: center;"><input v-model="checkTodas" type="checkbox"></th>
                            <th style="text-align: center;"></th>
                            <th style="text-align: center;">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'  }}</th>
                            <th style="text-align: center;">Abono</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="albaran in albaranes" :key="albaran.id_albaran">
                            <td>{{ albaran.numero }}</td>
                            <td>{{ albaran.fecha }}</td>
                            <td style="display: flex;gap:5px; align-items: center"><b style="cursor: pointer;" @click="irServicio(albaran)">{{ albaran.expediente }}</b><span style="color: rgb(134, 134, 134);">{{ albaran.relacionados }}</span></td>
                            <td>{{ albaran.cliente }}</td>
                            <td>{{ albaran.importe_base }}€</td>
                            <td>{{ albaran.factura }}</td>
                            <td v-if="albaran.factura">
                                
                            </td>
                            <td v-else style="text-align: center;">
                                <input @change="marcado(albaran)" v-model="albaran.marcada" type="checkbox">
                            </td>
                            <td v-if="albaran.factura" style="text-align: center;">
                                <button class="btn" @click="descargarFactura(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                            </td>
                            <td v-else>
                                
                            </td>
                            <td v-if="albaran.factura" style="text-align: center;">
                                <button class="btn btn-sm btn-danger" @click="confirmarEliminar(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'"><i class="fas fa-times"></i></button>
                            </td>
                            <td v-else>
                                
                            </td>
                            <td v-if="albaran.factura && albaran.importe_pendiente > 0" style="text-align: center;">
                                <button @click="botonabonar(albaran)" class="btn btn-sm btn-light" style="border: 1px solid grey;">Generar rectificativa</button>
                            </td>
                            <td v-else>
                                
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><strong>{{ importe_base }}€</strong></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card" v-if="albaranesCSVVisibles">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Nº Albarán</th>
                        <th>Fecha Albarán</th>
                        <th>Expediente</th>
                        <th>Cliente</th>
                        <th>Importe</th>
                        <th>{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Registro' : 'Factura'  }}</th>
                        <th style="text-align: center;" ><input v-model="checkTodasCSV" type="checkbox"></th>
                        <th></th>
                        <th>{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'  }}</th>
                        <th>Abono</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="albaran in albaranesCSV" :key="albaran.id_albaran">
                        <td>{{ albaran.numero }}</td>
                        <td>{{ albaran.fecha }}</td>
                        <td style="display: flex;gap:5px; align-items: center"><b style="cursor: pointer;" @click="irServicio(albaran)">{{ albaran.expediente }}</b><span style="color: rgb(134, 134, 134);">{{ albaran.relacionados }}</span></td>
                        <td>{{ albaran.cliente }}</td>
                        <td>{{ albaran.importe_base }}€</td>
                        <td>
                            <div v-if="albaran.id_albaran">
                                <div v-if="albaran.csv && albaran.csv.numero">
                                    <p style="margin-bottom: 0px;">Nº{{ albaran.csv.numero }}</p>
                                    <p style="margin-bottom: 0px;">Fecha:{{ albaran.csv.fecha }}</p>
                                </div>
                                <p style="margin-bottom: 0px;">{{ albaran.csv.importe }} €</p>
                            </div>
                        </td>
                        <td v-if="albaran.factura">
                                
                        </td>
                        <td v-else style="text-align: center;">
                            <input @change="marcadoCSV(albaran)" v-model="albaran.marcada" type="checkbox">
                        </td>
                        <td v-if="albaran.factura" style="text-align: center;">
                            <button class="btn" @click="descargarFactura(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                        </td>
                        <td v-else-if="facturas_generadas[albaran.id_albaran]">
                            <button class="btn" @click="descargarFacturaGenerada(facturas_generadas[albaran.id_albaran].url_completa_factura_pdf)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                        </td>
                        <td v-else>
                            
                        </td>
                        <td v-if="albaran.factura" style="text-align: center;">
                            <button class="btn btn-sm btn-danger" @click="confirmarEliminar(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'"><i class="fas fa-times"></i></button>
                        </td>
                        <td v-else>
                            
                        </td>
                        <td v-if="albaran.factura && albaran.importe_pendiente > 0" style="text-align: center;">
                            <button @click="botonabonar(albaran)" class="btn btn-sm btn-light" style="border: 1px solid grey;">Generar rectificativa</button>
                        </td>
                        <td v-else>
                            
                        </td>
                    </tr>
    
                    <tr style="background-color: crimson;" v-for="error in erroresCSV" :key="error">
                        <td style="color: white">
                            No coincide!
                        </td>
                        <td></td>
                        <td v-if="error.expediente" style="display: flex; align-items: center; gap: 5px"><b style="cursor: pointer;" @click="irServicio(albaran)">
                            {{ error.expediente }}</b><span style="color: rgb(134, 134, 134);">{{ error.relacionados }}</span>                        
                        </td>
                        <td v-else>
    
                        </td>
                        <td></td>
                        <td style="color: white">{{ error.importe_csv }}€</td>
                        <td v-if="error.numero" style="color: white">Nº{{ error.numero }} Fecha:{{ error.fecha }}</td>
                        <td v-else></td>
                        <td></td>
                        <td colspan="3" style="color: white">{{ error.error }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><strong>{{ importe_base_csv }}€</strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card" v-if="albaranesCSVLDVisibles">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Nº Albarán</th>
                        <th>Fecha Albarán</th>
                        <th>Expediente</th>
                        <th>Cliente</th>
                        <th>Importe</th>
                        <th>{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Registro' : 'Factura'  }}</th>
                        <th style="text-align: center;"><input v-model="checkTodasCSVLD" type="checkbox"></th>
                        <th></th>
                        <th>{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'  }}</th>
                        <th>Abono</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="albaran in albaranesCSVLD" :key="albaran.id_albaran">
                        <td>{{ albaran.numero }}</td>
                        <td>{{ albaran.fecha }}</td>
                        <td style="display: flex;gap:5px; align-items: center"><b style="cursor: pointer;" @click="irServicio(albaran)">{{ albaran.expediente }}</b><span style="color: rgb(134, 134, 134);">{{ albaran.relacionados }}</span></td>
                        <td>{{ albaran.cliente }}</td>
                        <td>{{ albaran.importe_base }}€</td>
                        <td>
                            <div v-if="albaran.id_albaran">
                                <div v-if="albaran.csv && albaran.csv.numero">
                                    <p style="margin-bottom: 0px;">Nº{{ albaran.csv.numero }}</p>
                                    <p style="margin-bottom: 0px;">Fecha:{{ albaran.csv.fecha }}</p>
                                </div>
                                <p style="margin-bottom: 0px;">{{ albaran.csv.importe }} €</p>
                            </div>
                        </td>
                        <td v-if="albaran.factura">
                                
                        </td>
                        <td v-else style="text-align: center;">
                            <input @change="marcadoCSVLD(albaran)" v-model="albaran.marcada" type="checkbox">
                        </td>
                        <td v-if="albaran.factura" style="text-align: center;">
                            <button class="btn" @click="descargarFactura(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                        </td>
                        <td v-else-if="facturas_generadas[albaran.id_albaran]">
                            <button class="btn" @click="descargarFacturaGenerada(facturas_generadas[albaran.id_albaran].url_completa_factura_pdf)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                        </td>
                        <td v-else>
                            
                        </td>
                        <td v-if="albaran.factura" style="text-align: center;">
                            <button class="btn btn-sm btn-danger" @click="confirmarEliminar(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Anular registro' : 'Eliminar factura'"><i class="fas fa-times"></i></button>
                        </td>
                        <td v-else>
                            
                        </td>
                        <td v-if="albaran.factura && albaran.importe_pendiente > 0" style="text-align: center;">
                            <button @click="botonabonar(albaran)" class="btn btn-sm btn-light" style="border: 1px solid grey;">Generar rectificativa</button>
                        </td>
                        <td v-else>
                            
                        </td>
                    </tr>
    
                    <tr style="background-color: crimson;" v-for="error in erroresCSVLD" :key="error">
                        <td style="color: white">
                            No coincide!
                        </td>
                        <td></td>
                        <td v-if="error.expediente" style="display: flex; align-items: center; gap: 5px"><b style="cursor: pointer;" @click="irServicio(albaran)">
                            {{ error.expediente }}</b><span style="color: rgb(134, 134, 134);">{{ error.relacionados }}</span>
                        </td>
                        <td v-else>
    
                        </td>
                        <td></td>
                        <td style="color: white">{{ error.importe_csv }}€</td>
                        <td v-if="error.numero" style="color: white">Nº{{ error.numero }} Fecha:{{ error.fecha }}</td>
                        <td v-else>
    
                        </td>
                        <td></td>
                        <td colspan="3" style="color: white">{{ error.error }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><strong>{{ importe_base_csvld }}€</strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card" v-if="albaranesPDFVisibles">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th>Nº Albarán</th>
                        <th>Fecha Albarán</th>
                        <th>Expediente</th>
                        <th>Cliente</th>
                        <th>Importe</th>
                        <th>{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Registro' : 'Factura'  }}</th>
                        <th style="text-align: center;"><input v-model="checkTodasPDF" type="checkbox"></th>
                        <th></th>
                        <th>{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'  }}</th>
                        <th>Abono</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="albaran in albaranesPDF" :key="albaran.id_albaran">
                        <td>{{ albaran.numero }}</td>
                        <td>{{ albaran.fecha }}</td>
                        <td style="display: flex;gap:5px; align-items: center"><b style="cursor: pointer;" @click="irServicio(albaran)">{{ albaran.expediente }}</b><span style="color: rgb(134, 134, 134);">{{ albaran.relacionados }}</span></td>
                        <td>{{ albaran.cliente }}</td>
                        <td>{{ albaran.importe_base }}€</td>
                        <td>{{ albaran.factura }}</td>
                        <td v-if="albaran.factura">
                                
                        </td>
                        <td v-else style="text-align: center;">
                            <input @change="marcadoPDF(albaran)" v-model="albaran.marcada" type="checkbox">
                        </td>
                        <td v-if="albaran.factura" style="text-align: center;">
                            <button class="btn" @click="descargarFactura(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                        </td>
                        <td v-else-if="facturas_generadas[albaran.id_albaran]">
                            <button class="btn" @click="descargarFacturaGenerada(facturas_generadas[albaran.id_albaran].url_completa_factura_pdf)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                        </td>
                        <td v-else>
                            
                        </td>
                        <td v-if="albaran.factura" style="text-align: center;">
                            <button class="btn btn-sm btn-danger" @click="confirmarEliminar(albaran)" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'"><i class="fas fa-times"></i></button>
                        </td>
                        <td v-else>
                            
                        </td>
                        <td v-if="albaran.factura && albaran.importe_pendiente > 0" style="text-align: center;">
                            <button @click="botonabonar(albaran)" class="btn btn-sm btn-light" style="border: 1px solid grey;">Generar rectificativa</button>
                        </td>
                        <td v-else>
                            
                        </td>
                    </tr>
    
                    <tr style="background-color: crimson;" v-for="error in erroresPDF" :key="error">
                        <td style="color: white">
                            No coincide!
                        </td>
                        <td></td>
                        <td v-if="error.expediente" style="display: flex; align-items: center; gap: 5px"><b style="cursor: pointer;" @click="irServicio(albaran)">
                            {{ error.expediente }}</b><span style="color: rgb(134, 134, 134);">{{ error.relacionados }}</span>
                        </td>
                        <td v-else>
    
                        </td>
                        <td></td>
                        <td style="color: white">{{ error.importe_pdf }}€</td>
                        <td v-if="error.numero" style="color: white">Nº{{ error.numero }} Fecha:{{ error.fecha }}</td>
                        <td v-else>
    
                        </td>
                        <td></td>
                        <td colspan="3" style="color: white">{{ error.error }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><strong>{{ importe_base_pdf }}€</strong></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <Dialog :style="{ width: '25rem' }" @hide="cerrarForm" :header="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Eliminar registro' : 'Eliminar factura'" modal
        v-model:visible="dialogeliminar">
            <div>
                <textarea id="" style="width: 100%; margin: 10px 0" v-model="motivoEliminar" placeholder="Indique un motivo"></textarea>
            </div>
            <div style="display: flex; justify-content: end; gap: 15px;">
                <button @click="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? eliminarRegistro() : eliminarAlbaran()" class="btn btn-sm btn-primary">Eliminar</button>
                <button @click="cerrarForm" class="btn btn-sm btn-light">Cancelar</button>
            </div>
        </Dialog>
        <Dialog @hide="cerrarFormAbonar" header="Rectificar registro" modal v-model:visible="dialogabonar">
            <div class="card">
                <div class="card-body" style="padding: 0px;">
                    <table class="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>
                                    Factura a rectificar
                                </th>
                                <th>
                                    Importe total
                                </th>
                                <th>
                                    Ya rectificado
                                </th>
                                <th>
                                    Numero factura
                                </th>
                                <th>
                                    Importe a rectificar
                                </th>
                                <th>
                                    IVA
                                </th>
                                <th>
                                    Concepto
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {{ albaranaabonar.numero_factura }}
                                </td>
                                <td>
                                    {{ albaranaabonar.importe_base }}
                                </td>
                                <td>
                                    {{ albaranaabonar.importe_abonado }}
                                </td>
                                <td>
                                    <input class="form-control form-control-sm" type="number" v-model="numeroFacturaAbonar">
                                </td>
                                <td>
                                    <input class="form-control form-control-sm" type="number" v-model="importeFacturaAbonar" :disabled="albaranaabonar.abonos.parciales==0">
                                </td>
                                <td>
                                    <select class="form-control form-control-sm" v-model="ivaAbono" id="">
                                        <option v-for="impuesto in impuestos" :key="impuesto.id" :value="impuesto.valor_iva">{{ impuesto.valor_iva }}</option>
                                    </select>
                                </td>
                                <td>
                                    <input class="form-control form-control-sm" type="text" v-model="conceptoFacturaAbonar">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div style="display: flex; justify-content: end; gap: 15px;">
                <button @click="abonarFactura" class="btn btn-sm btn-primary">Rectificar</button>
                <button @click="cerrarFormAbonar" class="btn btn-sm btn-light">Cancelar</button>
            </div>
        </Dialog>
        <div class="card" v-if="albaranesPDFVisibles">
            <div class="card-header p-1 pt-1">
                <ul class="nav nav-pills" ref="tabHeaders">
                    <li  class="nav-item">
                        <a class="nav-link active" href="#facturapdf" data-toggle="tab">
                            {{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Crear factura'  }}
                        </a>
                    </li>
                </ul>
            </div>    
            <div class="card-body" style="padding: 0px;">
                <div class="tab-content" ref="tabContents">
                    <div class="tab-pane active container-grid" id="facturapdf">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Destinatario</th>
                                    <th>Empresa emisora</th>
                                    <th>Forma pago</th>
                                    <th>I.V.A.</th>
                                    <th>Fecha</th>
                                    <th>Numeración</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select v-model="destinatarioPDFFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cliente</option>
                                            <option v-for="comp in Object.entries(destinatariosPDFFactura)" :key="comp[0]" :value="comp[0]">{{ comp[1].nombre }}({{ comp[1].prefijo }})</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select v-model="empresaPDFFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione empresa</option>
                                            <option v-for="empr in empresasPDFFactura" :key="empr.id" :value="empr.id">{{ empr.nombre }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select style="width: 250px;" v-model="formapagoPDFFactura" class="form-control form-control-sm" name="" id="">
                                            <option v-for="formas in formaspagoPDFFactura" :key="formas">{{ formas }}</option>
                                        </select>
                                        <select style="width: 250px;" v-model="cuentaPDFFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cuenta</option>
                                            <option v-for="cuenta in cuentasPDFFactura" :value="cuenta" :key="cuenta.id_cuenta">{{ cuenta.iban_cuenta }}-{{ cuenta.iban2_cuenta }}-{{ cuenta.entidad_cuenta }}-{{ cuenta.oficina_cuenta }}-{{ cuenta.control_cuenta }}-{{ cuenta.numero_cuenta }} ({{ cuenta.nombre_banco }})</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select class="form-control form-control-sm" v-model="ivaPDFFactura" id="">
                                            <option v-for="iva in ivasPDFFactura" :key="iva" :value="iva">{{ iva }}%</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input style="width: 120px;" v-if="destinatarioPDFFactura!=''" class="form-control form-control-sm" type="date" v-model="fechaPDFFactura">
                                    </td>
                                    <td>
                                        <div class="row" v-if="destinatarioPDFFactura!=''">
                                            <select style="width: 100px;" class="form-control form-control-sm" v-model="seriePDFFactura" id="">
                                                <option v-for="serie in seriesPDFFactura" :key="serie.id" :value="serie">{{ serie.nombre }}</option>
                                            </select>
                                            <input style="width: 80px;" class="form-control form-control-sm" type="text" v-model="numeroPDFFactura">
                                            <select style="width: 80px;" class="form-control form-control-sm" v-model="añoPDFFactura" id="">
                                                <option v-for="año in añosPDFFacturas" :key="año" :value="año">{{ año }}</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td style="text-align: center;" v-if="!facturaPDFGenerada">
                                        <button class="btn btn-sm btn-primary" @click="generarFacturaPDF">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Generar una factura'  }}</button>
                                    </td>
                                    <td style="align-items: center;" v-else>
                                        {{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'  }}<button class="btn" @click="descargarFacturaPDFCreada()" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">Albaranes seleccionados</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="totales in Object.entries(totalesPDFFactura)" :key="totales[0]">
                                    <td style="display: grid; grid-template-columns: 1fr 5fr">
                                        <div style="text-align: center;">
                                        <p>Total({{ totales[0] }}%)</p>
                                        </div>
                                        <div>
                                            <p>{{ totales[1].total }}€</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>            
            </div>
        </div>    
        <div class="card" v-if="albaranesCSVVisibles">
            <div class="card-header p-1 pt-1">
                <ul class="nav nav-pills" ref="tabHeaders">
                    <li  class="nav-item">
                        <a class="nav-link active" href="#facturacsv" data-toggle="tab">
                            {{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Crear factura'  }}
                        </a>
                    </li>
                    <li v-if="variasfacturasCSV" class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#facturascsv">
                            Crear una factura por albarán
                        </a>
                    </li>
                </ul>
            </div>    
            <div class="card-body" style="padding: 0px;">
                <div class="tab-content" ref="tabContents">
                    <div class="tab-pane active container-grid" id="facturacsv">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Destinatario</th>
                                    <th>Empresa emisora</th>
                                    <th>Forma pago</th>
                                    <th>I.V.A.</th>
                                    <th>Fecha</th>
                                    <th>Numeración</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select v-model="destinatarioCSVFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cliente</option>
                                            <option v-for="comp in Object.entries(destinatariosCSVFactura)" :key="comp[0]" :value="comp[0]">{{ comp[1].nombre }}({{ comp[1].prefijo }})</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select v-model="empresaCSVFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione empresa</option>
                                            <option v-for="empr in empresasCSVFactura" :key="empr.id" :value="empr.id">{{ empr.nombre }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select style="width: 250px;" v-model="formapagoCSVFactura" class="form-control form-control-sm" name="" id="">
                                            <option v-for="formas in formaspagoCSVFactura" :key="formas">{{ formas }}</option>
                                        </select>
                                        <select style="width: 250px;" v-model="cuentaCSVFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cuenta</option>
                                            <option v-for="cuenta in cuentasCSVFactura" :value="cuenta" :key="cuenta.id_cuenta">{{ cuenta.iban_cuenta }}-{{ cuenta.iban2_cuenta }}-{{ cuenta.entidad_cuenta }}-{{ cuenta.oficina_cuenta }}-{{ cuenta.control_cuenta }}-{{ cuenta.numero_cuenta }} ({{ cuenta.nombre_banco }})</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select class="form-control form-control-sm" v-model="ivaCSVFactura" id="">
                                            <option v-for="iva in ivasCSVFactura" :key="iva" :value="iva">{{ iva }}%</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input style="width: 120px;" v-if="destinatarioCSVFactura!=''" class="form-control form-control-sm" type="date" v-model="fechaCSVFactura">
                                    </td>
                                    <td>
                                        <div class="row" v-if="destinatarioCSVFactura!=''">
                                            <select style="width: 100px;" class="form-control form-control-sm" v-model="serieCSVFactura" id="">
                                                <option v-for="serie in seriesCSVFactura" :key="serie.id" :value="serie">{{ serie.nombre }}</option>
                                            </select>
                                            <input style="width: 80px;" class="form-control form-control-sm" type="text" v-model="numeroCSVFactura">
                                            <select style="width: 80px;" class="form-control form-control-sm" v-model="añoCSVFactura" id="">
                                                <option v-for="año in añosCSVFacturas" :key="año" :value="año">{{ año }}</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td style="text-align: center;" v-if="!facturaCSVGenerada">
                                        <button class="btn btn-sm btn-primary" @click="generarFacturaCSV">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Generar una factura'  }}</button>
                                    </td>
                                    <td style="align-items: center;" v-else>
                                        {{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'  }}<button class="btn" @click="descargarFacturaCSVCreada()" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">Albaranes seleccionados</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="totales in Object.entries(totalesCSVFactura)" :key="totales[0]">
                                    <td style="display: grid; grid-template-columns: 1fr 5fr">
                                        <div style="text-align: center;">
                                        <p>Total({{ totales[0] }}%)</p>
                                        </div>
                                        <div>
                                            <p>{{ totales[1].total }}€</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane container-grid" id="facturascsv">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Forma pago</th>
                                    <th>Número</th>
                                    <th v-if="!facturasCSVGenerada"></th>
                                    <th v-else></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select v-model="formapagoCSVFactura" class="form-control form-control-sm" name="" id="">
                                            <option v-for="formas in formaspagoCSVFactura" :key="formas">{{ formas }}</option>
                                        </select>
                                        <select v-model="cuentaCSVFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cuenta</option>
                                            <option v-for="cuenta in cuentasCSVFactura" :value="cuenta" :key="cuenta.id_cuenta">{{ cuenta.iban_cuenta }}-{{ cuenta.iban2_cuenta }}-{{ cuenta.entidad_cuenta }}-{{ cuenta.oficina_cuenta }}-{{ cuenta.control_cuenta }}-{{ cuenta.numero_cuenta }} ({{ cuenta.nombre_banco }})</option>
                                        </select>
                                    </td>
                                    <td v-if="serieCSVFactura2" style="gap: 15px">
                                        <label for="">Serie</label>
                                        <span class="ml-2 mr-2">{{ serieCSVFactura2.nombre }}</span>
                                        <label for="">Nº Actual</label>
                                        <span class="ml-2 mr-2">{{ serieCSVFactura2.numero }}</span>
                                        <label for="">Año fiscal</label>
                                        <select style="width: 100px;" class="form-control-sm ml-2 mr-2" v-model="añoCSVFiscal" id="">
                                            <option v-for="año in añosCSVFiscal" :key="año" :value="año">{{ año }}</option>
                                        </select>
                                    </td>
                                    <td v-else>
    
                                    </td>
                                    <td style="text-align: center;" v-if="!facturasCSVGenerada">
                                        <button class="btn btn-sm btn-primary" @click="generarFacturasCSV">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear un Registro Contable por albarán' : 'Generar una factura por albarán'  }}</button>
                                    </td>
                                    <td style="display: flex; align-items: center;" v-else>
                                        <p>Facturas generadas!</p>
                                    </td>                              
                                </tr>
                            </tbody>
                        </table>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">Albaranes seleccionados</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="totales in Object.entries(totalesCSVFactura)" :key="totales[0]">
                                    <td style="display: grid; grid-template-columns: 1fr 5fr">
                                        <div style="text-align: center;">
                                        <p>Total({{ totales[0] }}%)</p>
                                        </div>
                                        <div>
                                            <p>{{ totales[1].total }}€</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>            
            </div>
        </div>
        <div class="card" v-if="albaranesCSVLDVisibles">
            <div class="card-header p-1 pt-1">
                <ul class="nav nav-pills" ref="tabHeaders">
                    <li  class="nav-item">
                        <a class="nav-link active" href="#facturacsvld" data-toggle="tab">
                            {{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Crear factura'  }}
                        </a>
                    </li>
                    <li v-if="variasfacturasCSVLD" class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#facturascsvld">
                            Crear una factura por albarán
                        </a>
                    </li>
                </ul>
            </div>    
            <div class="card-body" style="padding: 0px;">
                <div class="tab-content" ref="tabContents">
                    <div class="tab-pane active container-grid" id="facturacsvld">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Destinatario</th>
                                    <th>Empresa emisora</th>
                                    <th>Forma pago</th>
                                    <th>I.V.A.</th>
                                    <th>Fecha</th>
                                    <th>Numeración</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select v-model="destinatarioCSVLDFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cliente</option>
                                            <option v-for="comp in Object.entries(destinatariosCSVLDFactura)" :key="comp[0]" :value="comp[0]">{{ comp[1].nombre }}({{ comp[1].prefijo }})</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select v-model="empresaCSVLDFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione empresa</option>
                                            <option v-for="empr in empresasCSVLDFactura" :key="empr.id" :value="empr.id">{{ empr.nombre }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select style="width: 250px;" v-model="formapagoCSVLDFactura" class="form-control form-control-sm" name="" id="">
                                            <option v-for="formas in formaspagoCSVLDFactura" :key="formas">{{ formas }}</option>
                                        </select>
                                        <select style="width: 250px;" v-model="cuentaCSVLDFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cuenta</option>
                                            <option v-for="cuenta in cuentasCSVLDFactura" :value="cuenta" :key="cuenta.id_cuenta">{{ cuenta.iban_cuenta }}-{{ cuenta.iban2_cuenta }}-{{ cuenta.entidad_cuenta }}-{{ cuenta.oficina_cuenta }}-{{ cuenta.control_cuenta }}-{{ cuenta.numero_cuenta }} ({{ cuenta.nombre_banco }})</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select class="form-control form-control-sm" v-model="ivaCSVLDFactura" id="">
                                            <option v-for="iva in ivasCSVLDFactura" :key="iva" :value="iva">{{ iva }}%</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input style="width: 120px;" v-if="destinatarioCSVLDFactura!=''" class="form-control form-control-sm" type="date" v-model="fechaCSVLDFactura">
                                    </td>
                                    <td>
                                        <div class="row" v-if="destinatarioCSVLDFactura!=''">
                                            <select style="width: 100px;" class="form-control form-control-sm" v-model="serieCSVFactura" id="">
                                                <option v-for="serie in seriesCSVLDFactura" :key="serie.id" :value="serie">{{ serie.nombre }}</option>
                                            </select>
                                            <input style="width: 80px;" class="form-control form-control-sm" type="text" v-model="numeroCSVLDFactura">
                                            <select style="width: 80px;" class="form-control form-control-sm" v-model="añoCSVLDFactura" id="">
                                                <option v-for="año in añosCSVLDFacturas" :key="año" :value="año">{{ año }}</option>
                                            </select>
                                        </div>
                                    </td>
                                    <td style="text-align: center;" v-if="!facturaCSVLDGenerada">
                                        <button class="btn btn-sm btn-primary" @click="generarFacturaCSVLD">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Generar una factura'  }}</button>
                                    </td>
                                    <td style="align-items: center;" v-else>
                                        {{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'  }}<button class="btn" @click="descargarFacturaCSVLDCreada()" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">Albaranes seleccionados</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="totales in Object.entries(totalesCSVLDFactura)" :key="totales[0]">
                                    <td style="display: grid; grid-template-columns: 1fr 5fr">
                                        <div style="text-align: center;">
                                        <p>Total({{ totales[0] }}%)</p>
                                        </div>
                                        <div>
                                            <p>{{ totales[1].total }}€</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane container-grid" id="facturascsvld">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Forma pago</th>
                                    <th>Número</th>
                                    <th v-if="!facturasCSVLDGenerada"></th>
                                    <th v-else></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select v-model="formapagoCSVLDFactura" class="form-control form-control-sm" name="" id="">
                                            <option v-for="formas in formaspagoCSVLDFactura" :key="formas">{{ formas }}</option>
                                        </select>
                                        <select v-model="cuentaCSVLDFactura" class="form-control form-control-sm" name="" id="">
                                            <option value="">Seleccione cuenta</option>
                                            <option v-for="cuenta in cuentasCSVLDFactura" :value="cuenta" :key="cuenta.id_cuenta">{{ cuenta.iban_cuenta }}-{{ cuenta.iban2_cuenta }}-{{ cuenta.entidad_cuenta }}-{{ cuenta.oficina_cuenta }}-{{ cuenta.control_cuenta }}-{{ cuenta.numero_cuenta }} ({{ cuenta.nombre_banco }})</option>
                                        </select>
                                    </td>
                                    <td v-if="serieCSVLDFactura2" style="gap: 15px;">
                                        <label for="">Serie</label>
                                        <span class="ml-2 mr-2">{{ serieCSVLDFactura2.nombre }}</span>
                                        <label for="">Nº Actual</label>
                                        <span class="ml-2 mr-2">{{ serieCSVLDFactura2.numero }}</span>
                                        <label for="">Año fiscal</label>
                                        <select style="width: 100px;" class="form-control-sm ml-2 mr-2" v-model="añoCSVLDFiscal" id="">
                                            <option v-for="año in añosCSVLDFiscal" :key="año" :value="año">{{ año }}</option>
                                        </select>
                                    </td>
                                    <td v-else>
    
                                    </td>
                                    <td style="text-align: center;" v-if="!facturasCSVLDGenerada">
                                        <button class="btn btn-sm btn-primary" @click="generarFacturasCSVLD">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear un Registro Contable por albarán' : 'Generar una factura por albarán'  }}</button>
                                    </td>
                                    <td style="display: flex; align-items: center;" v-else>
                                        <p>Facturas generadas!</p>
                                    </td>                              
                                </tr>
                            </tbody>
                        </table>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">Albaranes seleccionados</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="totales in Object.entries(totalesCSVFactura)" :key="totales[0]">
                                    <td style="display: grid; grid-template-columns: 1fr 5fr">
                                        <div style="text-align: center;">
                                        <p>Total({{ totales[0] }}%)</p>
                                        </div>
                                        <div>
                                            <p>{{ totales[1].total }}€</p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>            
            </div>
        </div>
        <div class="card" v-if="albaranesVisibles">
            <div class="card-header">
                <p class="card-title">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Crear factura'  }}</p>
            </div>
            <div class="card-body" style="padding: 0px;">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Destinatario</th>
                            <th>Empresa emisora</th>
                            <th>Forma pago</th>
                            <th>I.V.A.</th>
                            <th>Fecha</th>
                            <th>Numeración</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <select v-model="destinatarioFactura" class="form-control form-control-sm" name="" id="">
                                    <option value="">Seleccione cliente</option>
                                    <option v-for="comp in Object.entries(destinatariosFactura)" :key="comp[0]" :value="comp[0]">{{ comp[1].nombre }}({{ comp[1].prefijo }})</option>
                                </select>
                            </td>
                            <td>
                                <select v-model="empresaFactura" class="form-control form-control-sm" name="" id="">
                                    <option value="">Seleccione empresa</option>
                                    <option v-for="empr in empresasFactura" :key="empr.id" :value="empr.id">{{ empr.nombre }}</option>
                                </select>
                            </td>
                            <td>
                                <select style="width: 250px;" v-model="formapagoFactura" class="form-control form-control-sm" name="" id="">
                                    <option v-for="formas in formaspagoFactura" :key="formas">{{ formas }}</option>
                                </select>
                                <select style="width: 250px;" v-model="cuentaFactura" class="form-control form-control-sm" name="" id="">
                                    <option value="">Seleccione cuenta</option>
                                    <option v-for="cuenta in cuentasFactura" :value="cuenta" :key="cuenta.id_cuenta">{{ cuenta.iban_cuenta }}-{{ cuenta.iban2_cuenta }}-{{ cuenta.entidad_cuenta }}-{{ cuenta.oficina_cuenta }}-{{ cuenta.control_cuenta }}-{{ cuenta.numero_cuenta }} ({{ cuenta.nombre_banco }})</option>
                                </select>
                            </td>
                            <td>
                                <select class="form-control form-control-sm" v-model="ivaFactura" id="">
                                    <option v-for="iva in ivasFactura" :key="iva" :value="iva">{{ iva }}%</option>
                                </select>
                            </td>
                            <td>
                                <input style="width: 120px;" v-if="destinatarioFactura!=''" class="form-control form-control-sm" type="date" v-model="fechaFactura">
                            </td>
                            <td>
                                <div class="row" v-if="destinatarioFactura!=''">
                                    <select style="width: 100px;" class="form-control form-control-sm" v-model="serieFactura" id="">
                                        <option v-for="serie in seriesFactura" :key="serie.id" :value="serie">{{ serie.nombre }} ({{ serie.prefijo }})</option>
                                    </select>
                                    <input style="width: 80px;" class="form-control form-control-sm" type="text" v-model="numeroFactura">
                                    <select style="width: 80px;" class="form-control form-control-sm" v-model="añoFactura" id="">
                                        <option v-for="año in añosFacturas" :key="año" :value="año">{{ año }}</option>
                                    </select>
                                </div>
                            </td>
                            <td style="text-align: center;" v-if="!facturaGenerada">
                                <button class="btn btn-sm btn-primary" @click="generarFactura">{{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Crear Registro Contable' : 'Generar una factura'  }}</button>
                            </td>
                            <td style="align-items: center;" v-else>
                                {{ sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'  }}<button class="btn" @click="descargarFacturaCreada()" :title="sistema_facturacion == 'no_factura' || sistema_facturacion == 'verifactu' ? 'Ver registro' : 'Ver factura'"><i class="far fa-file-pdf"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table">
                    <thead>
                        <tr>
                            <th style="text-align: center;">Albaranes seleccionados</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="totales in Object.entries(totalesFactura)" :key="totales[0]">
                            <td style="display: grid; grid-template-columns: 1fr 5fr">
                                <div style="text-align: center;">
                                   <p>Total({{ totales[0] }}%)</p>
                                </div>
                                <div>
                                    <p>{{ totales[1].total }}€</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>    
    </div>
</template>
<script>
import jsonToCsvExport from "json-to-csv-export"
import $ from 'jquery';
import MultiSelect from 'primevue/multiselect';
import { PwgsApi } from '../../../services/PwgsApi';
import FileUpload from 'primevue/fileupload';
export default{    
    data(){
        return {
            companiasCargadas:false,
            sistema_facturacion: localStorage.getItem('sistema_facturacion'),
            spinner:false,
            conceptoFacturaAbonar:'',
            ivaAbono:'',
            impuestos:[],
            importeFacturaAbonar:'',
            numeroFacturaAbonar:'',
            companias:null,
            companiasSeleccionadas:[],
            empresas:null,
            empresaselec:'',
            fecha_inicio:'',
            fecha_fin:'',
            facturadoselec:'',
            busquedaNombre:'',
            numeroAlbaran:'',

            importe_total:0,
            
            importe_base:0,
            importe_base_csvld:0,
            importe_base_pdf:0,
            importe_base_csv:0,

            albaranes:[],
            albaranesCSV:[],
            albaranesCSVLD:[],
            albaranesPDF:[],

            albaranesVisibles:false,
            albaranesCSVVisibles:false,
            albaranesCSVLDVisibles:false,
            albaranesPDFVisibles:false,

            numerosExpedientes:'',

            incluirelacionados:false,
            incluirelacionadospdf:false,

            mostrarCSV:false,
            mostrarCSVLD:false,
            mostrarPDF:false,

            series:[],

            serieCSVseleccionada:'',
            serieCSVLDseleccionada:'', 

            incluiravisoscsv:false,
            incluiravisoscsvld:false,

            albaranes_csv:[],
            albaranes_csvld:[],

            archivoSubidocsv:'',
            archivoSubidocsvld:'',
            archivoSubidopdf:'',

            checkTodas:false,
            checkTodasCSV:false,
            checkTodasCSVLD:false,
            checkTodasPDF:false,

            facturaaeliminar:null,
            dialogeliminar : false,
            motivoEliminar:'',

            dialogabonar:false,
            albaranaabonar:null,

            ivaFactura:'',
            ivaCSVFactura:'',
            ivaCSVLDFactura:'',
            ivaPDFFactura:'',

            ivasFactura:[],
            ivasCSVFactura:[],
            ivasCSVLDFactura:[],
            ivasPDFVactura:[],

            destinatarioFactura:'',
            destinatarioCSVFactura:'',
            destinatarioCSVLDFactura:'',
            destinatarioPDFFactura:'',

            destinatariosFactura:[],
            destinatariosCSVFactura:[],
            destinatariosCSVLDFactura:[],
            destinatariosPDFFactura:[],   

            fechaFactura:'',
            fechaCSVFactura:'',
            fechaCSVLDFactura:'',
            fechaPDFFactura:'',

            numeroFactura:'',
            numeroCSVFactura:'',
            numeroCSVLDFactura:'',
            numeroPDFFactura:'',    

            añosFacturas:[],
            añosCSVFacturas:[],
            añosCSVLDFacturas:[],
            añosPDFFacturas:[],

            añosCSVFiscal:[],
            añosCSVLDFiscal:[],

            añoFactura:'',
            añoCSVFactura:'',
            añoCSVLDFactura:'',
            añoPDFFactura:'',

            añoCSVFiscal:'',
            añoCSVLDFiscal:'',

            formaspagoFactura:[],
            formaspagoCSVFactura:[],
            formaspagoCSVLDFactura:[],  
            fermaspagoPDFFactura:[],     

            formapagoFactura:'',
            formapagoCSVFactura:'',
            formapagoCSVLDFactura:'',
            formapagoPDFFactura:'',

            seriesFactura:[],
            seriesCSVFactura:[],
            seriesCSVLDFactura:[],  
            seriesPDFFactura:[],     

            serieFactura:'',
            serieCSVFactura:'',
            serieCSVLDFactura:'',   
            seriePDFFactura:'',

            serieCSVFactura2:'',
            serieCSVLDFactura2:'',

            cuentasFactura:[],
            cuentasCSVFactura:[],
            cuentasCSVLDFactura:[],
            cuentasPDFFactura:[],

            cuentaFactura:'',
            cuentaCSVFactura:'',
            cuentaCSVLDFactura:'',
            cuentaPDFFactura:'',

            empresaFactura:'',
            empresaCSVFactura:'',
            empresaCSVLDFactura:'',
            empresaPDFFactura:'',
            
            empresasFactura:[],
            empresasCSVFactura:[],
            empresasCSVLDFactura:[],
            empresasPDFFactura:[],
            
            año_actual:'',
            totalesFactura:'',
            totalesCSVFactura:'',
            totalesCSVLDFactura:'',
            totalesPDFFactura:'',
            
            albaranesMarcados:[],
            albaranesMarcadosCSV:[],
            albaranesMarcadosCSVLD:[],
            albaranesMarcadosPDF:[],

            dia_actual:'',
            
            facturaGenerada:false,
            facturaCSVGenerada:false,
            facturaCSVLDGenerada:false,
            facturaPDFGenerada:false,
            facturasCSVGenerada:false,
            facturasCSVLDGenerada:false,

            urlFacturaCreada:'',
            urlFacturaCSVCreada:'',
            urlFacturaCSVLDCreada:'',
            urlFacturaPDFCreada:'',

            erroresCSV:[],
            erroresCSVLD:[],
            erroresPDF:[],

            variasfacturasCSV:false,
            variasfacturasCSVLD:false,
            mostrarrelacionados:false,
            mostraravisos:false,

            facturas_generadas:[],
        }
    },
    components:{
        MultiSelect,
        FileUpload,
    },
    computed: {     
    },
    methods:{
        async abonarFactura(){
            try{
                const api = new PwgsApi();
                await api.post('facturas/'+this.albaranaabonar.id_factura+'/abonar', {importe: this.importeFacturaAbonar, concepto: this.conceptoFacturaAbonar, 
                    iva: this.ivaAbono, numero:this.numeroFacturaAbonar});
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Factura abonada correctamente', life: 2000 });
                this.cerrarFormAbonar();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        botonabonar(albaran){
            this.albaranaabonar = albaran;
            //if(albaran.abonos.parciales=='1'){
                albaran.importe_base = albaran.importe_base.replace(',', '.');            
                this.importeFacturaAbonar = parseFloat(albaran.importe_base);
                this.numeroFacturaAbonar = parseInt(albaran.siguiente_numero);
                this.conceptoFacturaAbonar='';
                this.ivaAbono = albaran.iva_defecto;
                this.dialogabonar = true;
            /*}else{
                this.confirmar();
            }*/
        },
        transformarFecha(fechaIng){
            const [año,mes,dia] = fechaIng.split('-');
            return `${dia}/${mes}/${año}`
        },
        confirmar(){
            this.$confirm.require({
                    message: '¿Seguro que quieres rectificar la factura?',
                    header: 'Confirmación',
                    icon: 'pi pi-exclamation-triangle',
                    rejectClass: 'p-button-secondary p-button-outlined',
                    rejectLabel: 'Cancelar',
                    acceptLabel: 'Aceptar',
                    accept: () => {
                    this.pagarfactura()
                    },
                    reject: () => {
                        return;
                    }
                });
            
        },
        async pagarfactura() {
            const api = new PwgsApi();
            try{
            await api.post('facturas/'+this.albaranaabonar.id_factura+'/abonar');
            this.$toast.add({ severity:'success', summary: 'Abonado', detail: 'Factura abonada', life: 2000 });            
            }catch(e){
            this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async generarFactura(){
            const api = new PwgsApi();
            if(this.albaranesMarcados.length < 1){
                alert('Debe seleccionar algún albarán.')
                return;
            }
            if(this.destinatarioFactura==''){
                alert('Debe seleccionar alguna compañía.')
                return;
            }
            if(this.empresaFactura==''){
                alert('Debe seleccionar alguna empresa.')
                return;
            }
            const body = {ids_albaranes: this.albaranesMarcados, id_compania:this.destinatarioFactura, id_empresa:this.empresaFactura,
                forma_pago:this.formapagoFactura,tipo_iva:this.ivaFactura, id_serie:this.serieFactura.id, numero:this.numeroFactura,
                year: this.añoFactura, fecha_factura:this.fechaFactura}
            if(this.formapagoFactura == 'Transferencia Bancaria'){
                if(this.cuentaFactura != ''){
                    var cuenta = this.cuentaFactura.iban_cuenta +'-'+this.cuentaFactura.iban2_cuenta +'-'+ this.cuentaFactura.entidad_cuenta +'-'+this.cuentaFactura.oficina_cuenta +'-'+this.cuentaFactura.control_cuenta +'-'+ this.cuentaFactura.numero_cuenta;
                    body.cuenta_bancaria=cuenta;
                }
            }
            try{
                const resp = await api.post('facturacion-albaranes/facturar', body);
                this.facturaGenerada = true;
                this.urlFacturaCreada = resp.url_completa_factura_pdf;
                this.actualizarLista();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async generarFacturaCSV(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosCSV.length < 1){
                alert('Debe seleccionar algún albarán.')
                return;
            }
            if(this.destinatarioCSVFactura==''){
                alert('Debe seleccionar alguna compañía.')
                return;
            }
            if(this.empresaCSVFactura==''){
                alert('Debe seleccionar alguna empresa.')
                return;
            }
            const body = {ids_albaranes: this.albaranesMarcadosCSV, id_compania:this.destinatarioCSVFactura, id_empresa:this.empresaCSVFactura,
                forma_pago:this.formapagoCSVFactura,tipo_iva:this.ivaCSVFactura, id_serie:this.serieCSVFactura.id, numero:this.numeroCSVFactura,
                year: this.añoCSVFactura, fecha_factura:this.fechaCSVFactura}
            if(this.formapagoCSVFactura == 'Transferencia Bancaria'){
                if(this.cuentaCSVFactura != ''){
                    var cuenta = this.cuentaCSVFactura.iban_cuenta +'-'+this.cuentaCSVFactura.iban2_cuenta +'-'+ this.cuentaCSVFactura.entidad_cuenta +'-'+this.cuentaCSVFactura.oficina_cuenta +'-'+this.cuentaCSVFactura.control_cuenta +'-'+ this.cuentaCSVFactura.numero_cuenta;
                    body.cuenta_bancaria=cuenta;
                }
            }
            try{
                const resp = await api.post('facturacion-albaranes/facturar', body);
                this.facturaCSVGenerada = true;
                this.urlFacturaCSVCreada = resp.url_completa_factura_pdf;
                this.actualizarListaCSV();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async generarFacturasCSV(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosCSV.length < 1){
                alert('Debe seleccionar algún albarán.')
                return;
            }
            const body = {forma_pago:this.formapagoCSVFactura, id_serie:this.serieCSVFactura2.id, 
                year: this.añoCSVFiscal}
            if(this.formapagoCSVFactura == 'Transferencia Bancaria'){
                if(this.cuentaCSVFactura != ''){
                    var cuenta = this.cuentaCSVFactura.iban_cuenta +'-'+this.cuentaCSVFactura.iban2_cuenta +'-'+ this.cuentaCSVFactura.entidad_cuenta +'-'+this.cuentaCSVFactura.oficina_cuenta +'-'+this.cuentaCSVFactura.control_cuenta +'-'+ this.cuentaCSVFactura.numero_cuenta;
                    body.cuenta_bancaria=cuenta;
                }
            }
            var albaranes = {};
            for(var alb of this.albaranesMarcadosCSV){
                for(var albcsv of Object.entries(this.albaranes_csv)){
                    if(albcsv[0] == alb){
                        albaranes[alb] = albcsv[1];
                    }
                }
            }
            body.albaranes_csv = albaranes;
            try{
                this.facturas_generadas = await api.post('facturacion-albaranes/facturar-por-albaran', body);
                /*this.facturasCSVGenerada = true;
                this.urlFacturaCSVCreada = resp.url_completa_factura_pdf;*/
                this.actualizarListaCSV();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async generarFacturaCSVLD(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosCSVLD.length < 1){
                alert('Debe seleccionar algún albarán.')
                return;
            }
            if(this.destinatarioCSVLDFactura==''){
                alert('Debe seleccionar alguna compañía.')
                return;
            }
            if(this.empresaCSVLDFactura==''){
                alert('Debe seleccionar alguna empresa.')
                return;
            }
            const body = {ids_albaranes: this.albaranesMarcadosCSVLD, id_compania:this.destinatarioCSVLDFactura, id_empresa:this.empresaCSVLDFactura,
                forma_pago:this.formapagoCSVLDFactura,tipo_iva:this.ivaCSVLDFactura, id_serie:this.serieCSVLDFactura.id, numero:this.numeroCSVLDFactura,
                year: this.añoCSVLDFactura, fecha_factura:this.fechaCSVLDFactura}
            if(this.formapagoCSVLDFactura == 'Transferencia Bancaria'){
                if(this.cuentaCSVLDFactura != ''){
                    var cuenta = this.cuentaCSVLDFactura.iban_cuenta +'-'+this.cuentaCSVLDFactura.iban2_cuenta +'-'+ this.cuentaCSVLDFactura.entidad_cuenta +'-'+this.cuentaCSVLDFactura.oficina_cuenta +'-'+this.cuentaCSVLDFactura.control_cuenta +'-'+ this.cuentaCSVLDFactura.numero_cuenta;
                    body.cuenta_bancaria=cuenta;
                }
            }
            try{
                const resp = await api.post('facturacion-albaranes/facturar', body);
                this.facturaCSVLDGenerada = true;
                this.urlFacturaCSVLDCreada = resp.url_completa_factura_pdf;
                this.actualizarListaCSVLD();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async generarFacturasCSVLD(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosCSVLD.length < 1){
                alert('Debe seleccionar algún albarán.')
                return;
            }
            const body = {forma_pago:this.formapagoCSVLDFactura, id_serie:this.serieCSVLDFactura2.id, 
                year: this.añoCSVLDFiscal}
            if(this.formapagoCSVLDFactura == 'Transferencia Bancaria'){
                if(this.cuentaCSVLDFactura != ''){
                    var cuenta = this.cuentaCSVLDFactura.iban_cuenta +'-'+this.cuentaCSVLDFactura.iban2_cuenta +'-'+ this.cuentaCSVLDFactura.entidad_cuenta +'-'+this.cuentaCSVLDFactura.oficina_cuenta +'-'+this.cuentaCSVLDFactura.control_cuenta +'-'+ this.cuentaCSVLDFactura.numero_cuenta;
                    body.cuenta_bancaria=cuenta;
                }
            }
            var albaranes = {};
            for(var alb of this.albaranesMarcadosCSVLD){
                for(var albcsv of Object.entries(this.albaranes_csvld)){
                    if(albcsv[0] == alb){
                        albaranes[alb] = albcsv[1];
                    }
                }
            }
            body.albaranes_csv = albaranes;
            try{
                this.facturas_generadas = await api.post('facturacion-albaranes/facturar-por-albaran', body);
                /*this.facturasCSVLDGenerada = true;
                this.urlFacturaCSVLDCreada = resp.url_completa_factura_pdf;*/
                this.actualizarListaCSVLD();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async generarFacturaPDF(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosPDF.length < 1){
                alert('Debe seleccionar algún albarán.')
                return;
            }
            if(this.destinatarioPDFFactura==''){
                alert('Debe seleccionar alguna compañía.')
                return;
            }
            if(this.empresaPDFFactura==''){
                alert('Debe seleccionar alguna empresa.')
                return;
            }
            const body = {ids_albaranes: this.albaranesMarcadosPDF, id_compania:this.destinatarioPDFFactura, id_empresa:this.empresaPDFFactura,
                forma_pago:this.formapagoPDFFactura,tipo_iva:this.ivaPDFFactura, id_serie:this.seriePDFFactura.id, numero:this.numeroPDFFactura,
                year: this.añoPDFFactura, fecha_factura:this.fechaPDFFactura}
            if(this.formapagoPDFFactura == 'Transferencia Bancaria'){
                if(this.cuentaPDFFactura != ''){
                    var cuenta = this.cuentaPDFFactura.iban_cuenta +'-'+this.cuentaPDFFactura.iban2_cuenta +'-'+ this.cuentaPDFFactura.entidad_cuenta +'-'+this.cuentaPDFFactura.oficina_cuenta +'-'+this.cuentaPDFFactura.control_cuenta +'-'+ this.cuentaPDFFactura.numero_cuenta;
                    body.cuenta_bancaria=cuenta;
                }
            }
            try{
                const resp = await api.post('facturacion-albaranes/facturar', body);
                this.facturaPDFGenerada = true;
                this.urlFacturaPDFCreada = resp.url_completa_factura_pdf;
                this.actualizarListaPDF();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },

        actualizarLista(){
            var aux = this.albaranes;
            this.albaranes = [];
            setTimeout(() => {
                this.albaranes = aux;
            }, 1000);
           
        },
        actualizarListaCSV(){
            var aux = this.albaranesCSV;
            this.albaranesCSV = [];
            setTimeout(() => {
                this.albaranesCSV = aux;
            }, 1000);
           
        },
        actualizarListaCSVLD(){
            var aux = this.albaranesCSVLD;
            this.albaranesCSVLD = [];
            setTimeout(() => {
                this.albaranesCSVLD = aux;
            }, 1000);
           
        },
        actualizarListaPDF(){
            var aux = this.albaranesPDF;
            this.albaranesPDF = [];
            setTimeout(() => {
                this.albaranesPDF = aux;
            }, 1000);
           
        },
        marcado(albaran){
            if(albaran.marcada){
                this.albaranesMarcados.push(albaran.id_albaran);
                this.destinatarioFactura = '';
                this.obtenerDatosFactura();
            }else{
                let index = this.albaranesMarcados.indexOf(albaran.id_albaran);
                if (index > -1) {
                    this.albaranesMarcados.splice(index, 1);
                }
                this.destinatarioFactura = '';
                this.obtenerDatosFactura();
            }
        },
        marcadoCSV(albaran){
            if(albaran.marcada){
                this.albaranesMarcadosCSV.push(albaran.id_albaran);
                this.destinatarioCSVFactura = '';
                this.obtenerDatosFacturaCSV();
            }else{
                let index = this.albaranesMarcadosCSV.indexOf(albaran.id_albaran);
                if (index > -1) {
                    this.albaranesMarcadosCSV.splice(index, 1);
                }
                this.destinatarioCSVFactura = '';
                this.obtenerDatosFacturaCSV();
            }
        },
        marcadoCSVLD(albaran){
            if(albaran.marcada){
                this.albaranesMarcadosCSVLD.push(albaran.id_albaran);
                this.destinatarioCSVLDFactura = '';
                this.obtenerDatosFacturaCSVLD();
            }else{
                let index = this.albaranesMarcadosCSVLD.indexOf(albaran.id_albaran);
                if (index > -1) {
                    this.albaranesMarcadosCSVLD.splice(index, 1);
                }
                this.destinatarioCSVLDFactura = '';
                this.obtenerDatosFacturaCSVLD();
            }
        },
        marcadoPDF(albaran){
            if(albaran.marcada){
                this.albaranesMarcadosPDF.push(albaran.id_albaran);
                this.destinatarioPDFFactura = '';
                this.obtenerDatosFacturaPDF();
            }else{
                let index = this.albaranesMarcadosPDF.indexOf(albaran.id_albaran);
                if (index > -1) {
                    this.albaranesMarcadosPDF.splice(index, 1);
                }
                this.destinatarioPDFFactura = '';
                this.obtenerDatosFacturaPDF();
            }
        },
        irServicio(albaran){
            this.$router.push({
                name: 'Servicio',
                params: {
                    id:albaran.id_servicio
                }
            });
        },
        confirmarEliminar(albaran) {
            this.facturaaeliminar = albaran;
            this.dialogeliminar=true;
        },
        cerrarForm(){
            this.dialogeliminar = false;
            this.motivoEliminar='';
            this.facturaaeliminar=null;
        },
        cerrarFormAbonar(){
            this.albaranaabonar = null;
            this.dialogabonar = false;
        },
        async eliminarAlbaran(){
            if(this.motivoEliminar==''){
                alert('Debe indicar un motivo.')
                return;
            }
            try{
                const api = new PwgsApi();
                const params = {motivo:this.motivoEliminar};
                await api.deletebody('facturas/' + this.facturaaeliminar.id_factura, params);
                this.facturaaeliminar.marcada = false;
                this.facturaaeliminar.factura = null;
                var albaranEncontrado = this.albaranes.filter(albaran => albaran == this.facturaaeliminar);
                albaranEncontrado.marcada = false;
                albaranEncontrado.factura = null;
                this.cerrarForm();
            }
            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async eliminarRegistro() {
            if(this.motivoEliminar==''){
                alert('Debe indicar un motivo.')
                return;
            }
            const api = new PwgsApi();            
            try{
                const params = {motivo:this.motivoEliminar};
                await api.deletebody('facturas/' + this.facturaaeliminar.id_factura + '/registro', params);
                this.$toast.add({ severity: 'success', summary: 'Anulado', detail: 'Registro eliminado', life: 2000 });
                this.facturaaeliminar.marcada = false;
                this.facturaaeliminar.factura = null;
                var albaranEncontrado = this.albaranes.filter(albaran => albaran == this.facturaaeliminar);
                albaranEncontrado.marcada = false;
                albaranEncontrado.factura = null;
                this.cerrarForm();
            }
            catch (e) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        descargarFactura(albaran){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            if(urlglobal == 'null.pwgs.app'){
                url  = albaran.url_completa_factura_pdf;//"https://desarrollofront.pwgs.app/"+albaran.url_factura_pdf;
            }else{
                url  = albaran.url_completa_factura_pdf;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        descargarFacturaGenerada(url){
            if(url){
                window.open(url, "Factura", "width=800, height=600");
            }
        },
        descargarFacturaCreada(){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            if(urlglobal == 'null.pwgs.app'){
                url  = this.urlFacturaCreada;//"https://desarrollofront.pwgs.app/"+this.urlFacturaCreada;
            }else{
                url  = this.urlFacturaCreada;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        descargarFacturaCSVCreada(){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            if(urlglobal == 'null.pwgs.app'){
                url  = this.urlFacturaCSVCreada;//"https://desarrollofront.pwgs.app/"+this.urlFacturaCSVCreada;
            }else{
                url  = this.urlFacturaCSVCreada;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        descargarFacturaCSVLDCreada(){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            if(urlglobal == 'null.pwgs.app'){
                url  = this.urlFacturaCSVLDCreada;//"https://desarrollofront.pwgs.app/"+this.urlFacturaCSVLDCreada;
            }else{
                url  = this.urlFacturaCSVLDCreada;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        descargarFacturaPDFCreada(){
            var urlglobal = localStorage.getItem('direccion');
            var url = '';
            if(urlglobal == 'null.pwgs.app'){
                url  = this.urlFacturaPDFCreada;//"https://desarrollofront.pwgs.app/"+this.urlFacturaPDFCreada;
            }else{
                url  = this.urlFacturaPDFCreada;
            }
            window.open(url, "Factura", "width=800, height=600");
        },
        marcarTodas(){
            if(!this.checkTodas){
                for(let albaran of this.albaranes){
                    if(!albaran.factura){
                        albaran.marcada = false;
                        this.albaranesMarcados = [];
                    }
                }
            }else{
                for(let albaran of this.albaranes){
                    if(!albaran.factura){
                        albaran.marcada = true;
                        this.albaranesMarcados.push(albaran.id_albaran);
                    }
                }
            }
            this.obtenerDatosFactura();
        },
        marcarTodasCSV(){
            if(!this.checkTodasCSV){
                for(let albaran of this.albaranesCSV){
                    if(!albaran.factura){
                        albaran.marcada = false;
                        this.albaranesMarcadosCSV = [];
                    }
                }
            }else{
                for(let albaran of this.albaranesCSV){
                    if(!albaran.factura){
                        albaran.marcada = true;
                        this.albaranesMarcadosCSV.push(albaran.id_albaran);
                    }
                }
            }
            this.obtenerDatosFacturaCSV();
        },
        marcarTodasCSVLD(){
            if(!this.checkTodasCSVLD){
                for(let albaran of this.albaranesCSVLD){
                    if(!albaran.factura){
                        albaran.marcada = false;
                        this.albaranesMarcadosCSVLD = [];
                    }
                }
            }else{
                for(let albaran of this.albaranesCSVLD){
                    if(!albaran.factura){
                        albaran.marcada = true;
                        this.albaranesMarcadosCSVLD.push(albaran.id_albaran);
                    }
                }
            }
            this.obtenerDatosFacturaCSVLD();
        },
        marcarTodasPDF(){
            if(!this.checkTodasPDF){
                for(let albaran of this.albaranesPDF){
                    if(!albaran.factura){
                        albaran.marcada = false;
                        this.albaranesMarcadosPDF = [];
                    }
                }
            }else{
                for(let albaran of this.albaranesPDF){
                    if(!albaran.factura){
                        albaran.marcada = true;
                        this.albaranesMarcadosPDF.push(albaran.id_albaran);
                    }
                }
            }
            this.obtenerDatosFacturaPDF();
        },
        subirarchivo(event) {
            this.archivoSubidocsv = event.files[0];
        },
        subirarchivold(event) {
            this.archivoSubidocsvld = event.files[0];
        },
        subirarchivoPdf(event) {
            this.archivoSubidopdf = event.files[0];
        },
        async mostrarAlbaranesBusqueda(){   
            this.spinner = true;
            var companias = [];       
            if(this.companiasSeleccionadas.length==0){
            if(this.companias){
                for(let compa of this.companias){
                    companias.push(compa.id);
                }
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    companias.push(compa.id);
                }
            }
            
            this.albaranes = [];
            const api = new PwgsApi();
            var body = {id_empresa: this.empresaselec, ids_companias:companias, fecha_inicio:this.fechaesp(this.fecha_inicio), fecha_fin:this.fechaesp(this.fecha_fin)};
            if(this.numeroAlbaran){
                body.numero = this.numeroAlbaran;
            }
            if(this.busquedaNombre){
                body.nombre = this.busquedaNombre;
            }
            if(this.facturadoselec){
                body.facturado = this.facturadoselec;
            }
            try{
                this.loading = true;
                const resp = await api.post('facturacion-albaranes/busqueda',body);
                console.log('respu', resp);
                for(let alb of Object.entries(resp)){
                    if(alb[0] == 'importe_totales'){
                        this.importe_total = alb[1];
                    }else if(alb[0] == 'importe_bases'){
                        this.importe_base = parseFloat(alb[1]).toFixed(2);
                    }else{
                        if(alb[1].fecha){
                            alb[1].fecha= this.transformarFecha(alb[1].fecha);
                        }
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        this.albaranes.push(alb[1]);
                    }
                }
            }catch(e){
                console.error(e);
                this.spinner = false;
            }finally{
                this.albaranesMarcados = [];
                this.facturaGenerada = false;
                this.urlFacturaCreada = '';
                this.obtenerDatosFactura();
                this.albaranesCSVVisibles = false;
                this.albaranesPDFVisibles = false;
                this.albaranesCSVLDVisibles = false;
                this.albaranesVisibles = true;
                this.spinner = false;
            }

        },
        async exportarCSVAlbaranesBusqueda(){
            var companias = [];       
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    companias.push(compa.id);
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    companias.push(compa.id);
                }
            }
            var albaranes = [];
            const api = new PwgsApi();
            var body = {id_empresa: this.empresaselec, ids_companias:companias, fecha_inicio:this.fechaesp(this.fecha_inicio), fecha_fin:this.fechaesp(this.fecha_fin)};
            if(this.numeroAlbaran){
                body.numero = this.numeroAlbaran;
            }
            if(this.busquedaNombre){
                body.nombre = this.busquedaNombre;
            }
            if(this.facturadoselec){
                body.facturado = this.facturadoselec;
            }
            try{                
                const resp = await api.post('facturacion-albaranes/busqueda',body);
                for(let alb of Object.entries(resp)){
                    if(alb[0] == 'importe_totales'){
                        //nada
                    }else if(alb[0] == 'importe_bases'){
                        var importe_base = parseFloat(alb[1]).toFixed(2);
                    }else{
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        albaranes.push(alb[1]);
                    }
                }
            }catch(e){
                console.error(e);
            }finally{               
                var grupoaux = [];                
                for(let albaran of albaranes){
                    var aux = {};
                    aux['Nº Albarán'] = albaran.numero;
                    aux['Fecha Albarán'] = albaran.fecha;
                    aux['Expediente'] = albaran.expediente;
                    aux['Cliente'] = albaran.cliente;
                    aux['Importe'] = albaran.importe_base;
                    grupoaux.push(aux);
                }
                var auxtotal={'Nº Albarán': 'Total', 'Fecha Albarán': '', 'Expediente': '', 'Cliente': '', 'Importe':importe_base};
                grupoaux.push(auxtotal);
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: Object.values(grupoaux), filename: 'Descarga_facturas_' + fechahoy, delimiter: ";" });  
            }
        },
        async obtenerDatosFactura(){
            const api = new PwgsApi();
            if(this.albaranesMarcados.length > 0){
                if(this.destinatarioFactura!=''){
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{ids_albaranes:this.albaranesMarcados,year:this.añoFactura,id_compania:this.destinatarioFactura,id_empresa:this.empresaFactura}); 
                    this.formaspagoFactura = siguiente.formas_pago;
                    this.seriesFactura = [];
                    this.formapagoFactura = siguiente.forma_pago_defecto;
                    this.cuentasFactura = siguiente.cuentas_bancarias;
                    this.ivasFactura = siguiente.tipos_iva;
                    for(var iva of this.ivasFactura){
                        this.ivaFactura = iva;
                        break;
                    }
                    this.totalesFactura = siguiente.totales;
                    this.empresasFactura = siguiente.empresas;
                    
                    if(this.empresasFactura && this.empresasFactura.length > 0){
                        this.empresaFactura = this.empresasFactura[0].id;
                    }
                    this.destinatariosFactura = siguiente.companias;
                    if(siguiente.series_compania_empresa){
                        for(var sers of Object.values(siguiente.series_compania_empresa)[0]){
                            this.seriesFactura.push(Object.values(sers.series)[0]);
                        }
                        for(var serie of Object.values(this.seriesFactura)){
                            this.serieFactura = serie;
                            break;
                        }
                    }
                }else{
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{ids_albaranes:this.albaranesMarcados,year:this.añoFactura}); 
                    this.formaspagoFactura = siguiente.formas_pago;
                    this.formapagoFactura = siguiente.forma_pago_defecto;
                    this.cuentasFactura = siguiente.cuentas_bancarias;
                    this.ivasFactura = siguiente.tipos_iva;
                    for(var iv of this.ivasFactura){
                        this.ivaFactura = iv;
                        break;
                    }
                    this.totalesFactura = siguiente.totales;
                    this.empresasFactura = siguiente.empresas;
                    this.destinatariosFactura = siguiente.companias;
                }
            }else{
                const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{ids_albaranes:[],year:this.añoFactura}); 
                this.formaspagoFactura = siguiente.formas_pago;
                this.formapagoFactura = siguiente.forma_pago_defecto;
                this.cuentasFactura = siguiente.cuentas_bancarias;
                this.ivasFactura = siguiente.tipos_iva;
                for(var ia of this.ivasFactura){
                        this.ivaFactura = ia;
                        break;
                    }
                this.totalesFactura = siguiente.totales;
                this.empresasFactura = [];
                this.empresaFactura = '';
                this.destinatariosFactura = [];
                this.destinatarioFactura = '';
            }
            this.fechaFactura = this.fechaing(this.dia_actual);
        },
        async obtenerDatosFacturaCSV(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosCSV.length > 0){
                if(this.destinatarioCSVFactura!=''){
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{id_serie:this.serieCSVseleccionada,ids_albaranes:this.albaranesMarcadosCSV,year:this.añoCSVFactura,id_compania:this.destinatarioCSVFactura,id_empresa:this.empresaCSVFactura}); 
                    this.formaspagoCSVFactura = siguiente.formas_pago;
                    this.formapagoCSVFactura = siguiente.forma_pago_defecto;
                    this.cuentasCSVFactura = siguiente.cuentas_bancarias;
                    this.ivasCSVFactura = siguiente.tipos_iva;
                    for(var iva of this.ivasCSVFactura){
                        this.ivaCSVFactura = iva;
                        break;
                    }
                    this.serieCSVFactura2 = '';
                    this.seriesCSVFactura = [];
                    if(siguiente.serie){
                        this.serieCSVFactura2 = siguiente.serie;
                        this.seriesCSVFactura.push(siguiente.serie);
                        this.serieCSVFactura = siguiente.serie;
                    }
                    this.totalesCSVFactura = siguiente.totales;
                    this.empresasCSVFactura = siguiente.empresas;

                    if(this.empresasCSVFactura && this.empresasCSVFactura.length > 0){
                        this.empresaCSVFactura = this.empresasCSVFactura[0].id;
                    }
                    this.destinatariosCSVFactura = siguiente.companias;   
                }else{
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{id_serie:this.serieCSVseleccionada,ids_albaranes:this.albaranesMarcadosCSV,year:this.añoCSVFactura}); 
                    this.formaspagoCSVFactura = siguiente.formas_pago;
                    this.formapagoCSVFactura = siguiente.forma_pago_defecto;
                    this.cuentasCSVFactura = siguiente.cuentas_bancarias;
                    this.ivasCSVFactura = siguiente.tipos_iva;
                    this.serieCSVFactura2 = siguiente.serie;
                    for(var iv of this.ivasCSVFactura){
                        this.ivaCSVFactura = iv;
                        break;
                    }
                    this.totalesCSVFactura = siguiente.totales;
                    this.empresasCSVFactura = siguiente.empresas;
                    this.empresaCSVFactura = '';
                    this.destinatariosCSVFactura = siguiente.companias;
                }
            }else{
                const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{id_serie:this.serieCSVseleccionada,ids_albaranes:[],year:this.añoCSVFactura}); 
                this.formaspagoCSVFactura = siguiente.formas_pago;
                this.formapagoCSVFactura = siguiente.forma_pago_defecto;
                this.cuentasCSVFactura = siguiente.cuentas_bancarias;
                this.ivasCSVFactura = siguiente.tipos_iva;
                this.serieCSVFactura2 = siguiente.serie;
                for(var ia of this.ivasCSVFactura){
                        this.ivaCSVFactura = ia;
                        break;
                    }
                this.totalesCSVFactura = siguiente.totales;
                this.empresasCSVFactura = [];
                this.empresaCSVFactura = '';
                this.destinatariosCSVFactura = [];
                this.destinatarioCSVFactura = '';
            }
            this.fechaCSVFactura = this.fechaing(this.dia_actual);
        },
        async obtenerDatosFacturaCSVLD(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosCSVLD.length > 0){
                if(this.destinatarioCSVLDFactura!=''){
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{id_serie:this.serieCSVLDseleccionada,ids_albaranes:this.albaranesMarcadosCSVLD,year:this.añoCSVLDFactura,id_compania:this.destinatarioCSVLDFactura,id_empresa:this.empresaCSVLDFactura}); 
                    this.formaspagoCSVLDFactura = siguiente.formas_pago;
                    this.formapagoCSVLDFactura = siguiente.forma_pago_defecto;
                    this.cuentasCSVLDFactura = siguiente.cuentas_bancarias;
                    this.ivasCSVLDFactura = siguiente.tipos_iva;
                    for(var iva of this.ivasCSVLDFactura){
                        this.ivaCSVLDFactura = iva;
                        break;
                    }
                    this.serieCSVLDFactura2 = '';
                    this.seriesCSVLDFactura = [];
                    if(siguiente.serie){
                        this.serieCSVLDFactura2 = siguiente.serie;
                        this.seriesCSVLDFactura.push(siguiente.serie);
                        this.serieCSVLDFactura = siguiente.serie;
                    }
                    this.totalesCSVLDFactura = siguiente.totales;
                    this.empresasCSVLDFactura = siguiente.empresas;

                    if(this.empresasCSVLDFactura && this.empresasCSVLDFactura.length > 0){
                        this.empresaCSVLDFactura = this.empresasCSVLDFactura[0].id;
                    }
                    this.destinatariosCSVLDFactura = siguiente.companias;
                }else{
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{id_serie:this.serieCSVLDseleccionada,ids_albaranes:this.albaranesMarcadosCSVLD,year:this.añoCSVLDFactura}); 
                    this.formaspagoCSVLDFactura = siguiente.formas_pago;
                    this.formapagoCSVLDFactura = siguiente.forma_pago_defecto;
                    this.cuentasCSVLDFactura = siguiente.cuentas_bancarias;
                    this.ivasCSVLDFactura = siguiente.tipos_iva;
                    this.serieCSVLDFactura2 = siguiente.serie;
                    for(var iv of this.ivasCSVLDFactura){
                        this.ivaCSVLDFactura = iv;
                        break;
                    }
                    this.totalesCSVLDFactura = siguiente.totales;
                    this.empresasCSVLDFactura = siguiente.empresas;
                    this.empresaCSVLDFactura = '';
                    this.destinatariosCSVLDFactura = siguiente.companias;
                }
            }else{
                const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{id_serie:this.serieCSVLDseleccionada,ids_albaranes:[],year:this.añoCSVLDFactura}); 
                this.formaspagoCSVLDFactura = siguiente.formas_pago;
                this.formapagoCSVLDFactura = siguiente.forma_pago_defecto;
                this.cuentasCSVLDFactura = siguiente.cuentas_bancarias;
                this.ivasCSVLDFactura = siguiente.tipos_iva;
                this.serieCSVLDFactura2 = siguiente.serie;
                for(var ia of this.ivasCSVLDFactura){
                        this.ivaCSVLDFactura = ia;
                        break;
                    }
                this.totalesCSVLDFactura = siguiente.totales;
                this.empresasCSVLDFactura = [];
                this.empresaCSVLDFactura = '';
                this.destinatariosCSVLDFactura = [];
                this.destinatarioCSVLDFactura = '';
            }
            this.fechaCSVLDFactura = this.fechaing(this.dia_actual);
        },
        async obtenerDatosFacturaPDF(){
            const api = new PwgsApi();
            if(this.albaranesMarcadosPDF.length > 0){
                if(this.destinatarioPDFFactura!=''){
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{ids_albaranes:this.albaranesMarcadosPDF,year:this.añoPDFFactura,id_compania:this.destinatarioPDFFactura,id_empresa:this.empresaPDFFactura}); 
                    this.formaspagoPDFFactura = siguiente.formas_pago;
                    this.formapagoPDFFactura = siguiente.forma_pago_defecto;
                    this.cuentasPDFFactura = siguiente.cuentas_bancarias;
                    this.ivasPDFFactura = siguiente.tipos_iva;
                    for(var iva of this.ivasPDFFactura){
                        this.ivaPDFFactura = iva;
                        break;
                    }
                    this.seriePDFFactura2 = '';
                    this.seriesPDFFactura = [];
                    if(siguiente.series_compania_empresa){
                        for(var sers of Object.values(siguiente.series_compania_empresa)[0]){
                            this.seriesPDFFactura.push(Object.values(sers.series)[0]);
                        }
                        for(var serie of Object.values(this.seriesFactura)){
                            this.seriePDFFactura = serie;
                            this.seriePDFFactura2 = serie;
                            break;
                        }
                    }
                    this.totalesPDFFactura = siguiente.totales;
                    this.empresasPDFFactura = siguiente.empresas;

                    if(this.empresasPDFFactura && this.empresasPDFFactura.length > 0){
                        this.empresaPDFFactura = this.empresasPDFFactura[0].id;
                    }
                    this.destinatariosPDFFactura = siguiente.companias;
                }else{
                    const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{ids_albaranes:this.albaranesMarcadosPDF,year:this.añoPDFFactura}); 
                    this.formaspagoPDFFactura = siguiente.formas_pago;
                    this.formapagoPDFFactura = siguiente.forma_pago_defecto;
                    this.cuentasPDFFactura = siguiente.cuentas_bancarias;
                    this.ivasPDFFactura = siguiente.tipos_iva;
                    for(var iv of this.ivasPDFFactura){
                        this.ivaPDFFactura = iv;
                        break;
                    }
                    this.totalesPDFFactura = siguiente.totales;
                    this.empresasPDFFactura = siguiente.empresas;
                    this.empresaPDFFactura = '';
                    this.destinatariosPDFFactura = siguiente.companias;
                    this.seriePDFFactura = '';  
                }
            }else{
                const siguiente = await api.post('/facturacion-albaranes/siguiente-numero',{ids_albaranes:[],year:this.añoPDFFactura}); 
                this.formaspagoPDFFactura = siguiente.formas_pago;
                this.formapagoPDFFactura = siguiente.forma_pago_defecto;
                this.cuentasPDFFactura = siguiente.cuentas_bancarias;
                this.ivasPDFFactura = siguiente.tipos_iva;
                for(var ia of this.ivasPDFFactura){
                        this.ivaPDFFactura = ia;
                        break;
                    }
                this.totalesPDFFactura = siguiente.totales;
                this.empresasPDFFactura = [];
                this.empresaPDFFactura = '';
                this.destinatariosPDFFactura = [];
                this.destinatarioPDFFactura = '';
                this.seriePDFFactura = '';  
            }
            this.fechaPDFFactura = this.fechaing(this.dia_actual);
        },
        obtenerNumero(){
            if(this.serieFactura != ''){
                this.numeroFactura = this.serieFactura.numero;
            }else{
                this.numeroFactura = '';
            }
        },
        obtenerNumeroCSV(){
            if(this.serieCSVFactura != ''){
                this.numeroCSVFactura = this.serieCSVFactura.numero;
            }else{
                this.numeroCSVFactura = '';
            }
        },
        obtenerNumeroCSVLD(){
            if(this.serieCSVLDFactura != ''){
                this.numeroCSVLDFactura = this.serieCSVLDFactura.numero;
            }else{
                this.numeroCSVLDFactura = '';
            }
        },
        obtenerNumeroPDF(){
            if(this.seriePDFFactura != ''){
                this.numeroPDFFactura = this.seriePDFFactura.numero;
            }else{
                this.numeroPDFFactura = '';
            }
        },
        async mostrarAlbaranesCSV(){
            
            this.albaranesCSV = [];
            this.erroresCSV = [];
            this.variasfacturasCSV = true;
            for(var compania of this.companiasSeleccionadas){
                if(compania.opcion_varias_facturas != '1'){
                    this.variasfacturasCSV = false;
                    break;
                }
            }
            var companias = '';       
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }
            if(this.archivoSubidocsv == ''){
                alert("Debe seleccionar algún archivo csv");
                return;
            }
            if(this.serieCSVseleccionada == ''){
                alert("Debe seleccionar alguna serie de facturación");
                return;
            }
            this.spinner = true;
            this.albaranes = [];
            const api = new PwgsApi();
            const formData = new FormData();
            formData.append('id_empresa', this.empresaselec);
            if(this.incluiravisoscsv){
                formData.append('incluir_avisos', '1');
            }
            formData.append('ids_companias', companias);
            formData.append('csv', this.archivoSubidocsv);
            try{
                const resp = await api.post('facturacion-albaranes/importacion-csv',formData);
                for(let alb of Object.entries(resp.albaranes)) {
                    if(alb[0] == 'importe_bases'){
                        this.importe_base_csv=alb[1];
                    }else if(alb[0] == 'importe_totales'){
                        //nada
                    }else{
                        if(alb[1].fecha){
                            alb[1].fecha= this.transformarFecha(alb[1].fecha);
                        }
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        if(resp.albaranes_csv){
                            Object.entries(resp.albaranes_csv).forEach(element => {
                                if(element[0]==alb[1].id_albaran){
                                    alb[1].csv = element[1];
                                }
                            })
                        }
                        this.albaranesCSV.push(alb[1]);
                    }
                }
                console.log('result',this.albaranesCSV);
                if(resp.errores){
                    this.erroresCSV = resp.errores;
                    for(let errors of this.erroresCSV){                        
                        var newerror = errors.error.replaceAll('\\u20ac' , '€');
                        errors.error = newerror;
                    }
                }
                if(resp.albaranes_csv){
                    this.albaranes_csv = resp.albaranes_csv;
                }
            }catch(e){
                this.spinner = false;
            }finally{
                this.obtenerDatosFacturaCSV();
                this.albaranesVisibles = false;
                this.albaranesCSVLDVisibles = false;
                this.albaranesPDFVisibles = false;
                this.albaranesCSVVisibles = true;           
                this.spinner = false;
            }
        },
        async exportarCSVAlbaranesCSV(){
            
            var albaranesCSV = [];
            var erroresCSV = [];
            for(var compania of this.companiasSeleccionadas){
                if(compania.opcion_varias_facturas != '1'){
                    this.variasfacturasCSV = false;
                    break;
                }
            }
            var companias = '';       
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }
            if(this.archivoSubidocsv == ''){
                alert("Debe seleccionar algún archivo csv");
                return;
            }
            if(this.serieCSVseleccionada == ''){
                alert("Debe seleccionar alguna serie de facturación");
                return;
            }
            this.albaranes = [];
            const api = new PwgsApi();
            const formData = new FormData();
            formData.append('id_empresa', this.empresaselec);
            if(this.incluiravisoscsv){
                formData.append('incluir_avisos', '1');
            }
            formData.append('ids_companias', companias);
            formData.append('csv', this.archivoSubidocsv);
            try{
                const resp = await api.post('facturacion-albaranes/importacion-csv',formData);                
                for(let alb of Object.entries(resp.albaranes)) {
                    if(alb[0] == 'importe_bases'){
                        var importe_base_csv = alb[1];
                    }else if(alb[0] == 'importe_totales'){
                       //nada
                    }else{
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        albaranesCSV.push(alb[1]);
                    }
                }
                if(resp.errores){
                    erroresCSV = resp.errores;
                    for(let errors of erroresCSV){
                        
                        var newerror = errors.error.replaceAll('\\u20ac' , '€');
                        errors.error = newerror;
                    }
                }
                if(resp.albaranes_csv){
                   //nada
                }
            }catch(e){
                console.log('Error:', e);
            }finally{
                var grupoaux = [];                
                for(let albaran of albaranesCSV){
                    var aux = {};
                    aux['Nº Albarán'] = albaran.numero;
                    aux['Fecha Albarán'] = albaran.fecha;
                    aux['Expediente'] = albaran.expediente;
                    aux['Cliente'] = albaran.cliente;
                    aux['Importe'] = albaran.importe_base;
                    aux['Error']='';
                    grupoaux.push(aux);
                }
                for(let error of erroresCSV){
                    var auxerr = {};
                    auxerr['Nº Albarán'] = '';
                    auxerr['Fecha Albarán'] = '';
                    auxerr['Expediente'] = '';
                    auxerr['Cliente'] = '';
                    auxerr['Importe'] = '';
                    auxerr['Error']=error.error;
                    grupoaux.push(auxerr);
                }
                var auxtotal={'Nº Albarán': 'Total', 'Fecha Albarán': '', 'Expediente': '', 'Cliente': '', 'Importe':importe_base_csv};
                grupoaux.push(auxtotal);
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: Object.values(grupoaux), filename: 'Descarga_facturas_' + fechahoy, delimiter: ";" });  
            }
        },       
        async mostrarAlbaranesCSVLD(){
            
            this.albaranesCSVLD = [];
            this.erroresCSVLD = [];
            this.variasfacturasCSVLD = true;
            for(var compania of this.companiasSeleccionadas){
                if(compania.opcion_varias_facturas != '1'){
                    this.variasfacturasCSVLD = false;
                    break;
                }
            }
            var companias = '';       
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }
            if(this.archivoSubidocsvld == ''){
                alert("Debe seleccionar algún archivo csv");
                return;
            }
            if(this.serieCSVLDseleccionada == ''){
                alert("Debe seleccionar alguna serie de facturación");
                return;
            }
            this.spinner = true;
            this.albaranes = [];
            const api = new PwgsApi();
            const formData = new FormData();
            formData.append('id_empresa', this.empresaselec);
            if(this.incluiravisoscsvld){
                formData.append('incluir_avisos', '1');
            }
            formData.append('ids_companias', companias);
            formData.append('csv', this.archivoSubidocsvld);
            try{
                const resp = await api.post('facturacion-albaranes/importacion-csv-ld',formData);
                for(let alb of Object.entries(resp.albaranes)) {
                    if(alb[0] == 'importe_bases'){
                        this.importe_base_csvld=alb[1];
                    }else if(alb[0] == 'importe_totales'){
                        //nada
                    }else{
                        if(alb[1].fecha){
                            alb[1].fecha= this.transformarFecha(alb[1].fecha);
                        }
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        if(resp.albaranes_csv){
                            Object.entries(resp.albaranes_csv).forEach(element => {
                                if(element[0]==alb[1].id_albaran){
                                    alb[1].csv = element[1];
                                }
                            })
                        }
                        this.albaranesCSVLD.push(alb[1]);
                    }
                }
                if(resp.errores){
                    this.erroresCSVLD = resp.errores;
                    for(let errors of this.erroresCSVLD){
                        var err = errors.error
                        var newerror = err.replaceAll('\\u20ac' , '€');
                        errors.error = newerror;
                    }
                }       
                if(resp.albaranes_csv){
                    this.albaranes_csvld = resp.albaranes_csv;
                }     
            }catch(e){
                console.log('error', e);
                this.spinner = false;
            }finally{
                this.obtenerDatosFacturaCSVLD();
                this.albaranesVisibles = false;
                this.albaranesCSVVisibles = false;
                this.albaranesPDFVisibles = false;
                this.albaranesCSVLDVisibles = true;
                this.spinner = false;
            }
        },
        async exportarCSVAlbaranesCSVLD(){
            
            var albaranesCSV = [];
            var erroresCSV = [];
            for(var compania of this.companiasSeleccionadas){
                if(compania.opcion_varias_facturas != '1'){
                    this.variasfacturasCSVLD = false;
                    break;
                }
            }
            var companias = '';       
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }
            if(this.archivoSubidocsvld == ''){
                alert("Debe seleccionar algún archivo csv");
                return;
            }
            if(this.serieCSVldseleccionada == ''){
                alert("Debe seleccionar alguna serie de facturación");
                return;
            }
            this.albaranes = [];
            const api = new PwgsApi();
            const formData = new FormData();
            formData.append('id_empresa', this.empresaselec);
            if(this.incluiravisoscsv){
                formData.append('incluir_avisos', '1');
            }
            formData.append('ids_companias', companias);
            formData.append('csv', this.archivoSubidocsvld);
            try{
                const resp = await api.post('facturacion-albaranes/importacion-csv-ld',formData);                
                for(let alb of Object.entries(resp.albaranes)) {
                    if(alb[0] == 'importe_bases'){
                        var importe_base_csv = alb[1];
                    }else if(alb[0] == 'importe_totales'){
                        //nada
                    }else{
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        albaranesCSV.push(alb[1]);
                    }
                }
                if(resp.errores){
                    erroresCSV = resp.errores;
                    for(let errors of erroresCSV){
                        
                        var newerror = errors.error.replaceAll('\\u20ac' , '€');
                        errors.error = newerror;
                    }
                }
                if(resp.albaranes_csv){
                    //nada
                }
            }catch(e){
                console.log('Error:', e);
            }finally{
                var grupoaux = [];                
                for(let albaran of albaranesCSV){
                    var aux = {};
                    aux['Nº Albarán'] = albaran.numero;
                    aux['Fecha Albarán'] = albaran.fecha;
                    aux['Expediente'] = albaran.expediente;
                    aux['Cliente'] = albaran.cliente;
                    aux['Importe'] = albaran.importe_base;
                    aux['Error']='';
                    grupoaux.push(aux);
                }
                for(let error of erroresCSV){
                    var auxerr = {};
                    auxerr['Nº Albarán'] = '';
                    auxerr['Fecha Albarán'] = '';
                    auxerr['Expediente'] = '';
                    auxerr['Cliente'] = '';
                    auxerr['Importe'] = '';
                    auxerr['Error']=error.error;
                    grupoaux.push(auxerr);
                }
                var auxtotal={'Nº Albarán': 'Total', 'Fecha Albarán': '', 'Expediente': '', 'Cliente': '', 'Importe':importe_base_csv};
                grupoaux.push(auxtotal);
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: Object.values(grupoaux), filename: 'Descarga_facturas_' + fechahoy, delimiter: ";" });  
            }
        },       
        async mostrarAlbaranesPDF(){
            this.spinner = true;
            this.albaranesPDF = [];
            this.erroresPDF = [];
            this.variasfacturasPDF = true;
            var companias = '';       
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }
            if(this.archivoSubidopdf == ''){
                alert("Debe seleccionar algún archivo PDF");
                this.spinner = false;
                return;
            }
            this.albaranes = [];
            const api = new PwgsApi();
            const formData = new FormData();
            formData.append('id_empresa', this.empresaselec);
            if(this.incluirelacionadospdf){
                formData.append('incluir_relacionados', '1');
            }
            formData.append('ids_companias', companias);
            formData.append('pdf', this.archivoSubidopdf);
            try{
                const resp = await api.post('facturacion-albaranes/importacion-pdf',formData);
                for(let alb of Object.entries(resp.albaranes)) {
                    if(alb[0] == 'importe_bases'){
                        this.importe_base_pdf=alb[1];
                    }else if(alb[0] == 'importe_totales'){
                        //nada
                    }else{
                        if(alb[1].fecha){
                            alb[1].fecha= this.transformarFecha(alb[1].fecha);
                        }
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        this.albaranesPDF.push(alb[1]);
                    }
                }
                if(resp.errores){
                    this.erroresPDF = resp.errores;
                    for(let errors of this.erroresPDF){
                        var err = errors.error
                        var newerror = err.replaceAll('\\u20ac' , '€');
                        errors.error = newerror;
                        errors.fecha = this.transformarFecha(errors.fecha);
                    }
                }            
            }catch(e){
                console.error('Error:', e);
                this.spinner = false;
            }finally{
                this.albaranesVisibles = false;
                this.albaranesCSVVisibles = false;
                this.albaranesCSVLDVisibles = false;
                this.albaranesPDFVisibles = true;
                this.spinner = false;
            }
        },
        async exportarCSVAlbaranesPDF(){
            var albaranesPDF = [];
            var erroresPDF = [];
            
            var companias = '';       
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    if(companias == ''){
                        companias = compa.id;    
                    }else{
                        companias = companias + ', '+compa.id;
                    }
                }
            }
            if(this.archivoSubidopdf == ''){
                alert("Debe seleccionar algún archivo PDF");
                return;
            }
            this.albaranes = [];
            const api = new PwgsApi();
            const formData = new FormData();
            formData.append('id_empresa', this.empresaselec);
            if(this.incluirelacionadospdf){
                formData.append('incluir_relacionados', '1');
            }
            formData.append('ids_companias', companias);
            formData.append('pdf', this.archivoSubidopdf);
            try{
                const resp = await api.post('facturacion-albaranes/importacion-pdf',formData);             
                for(let alb of Object.entries(resp.albaranes)) {
                    if(alb[0] == 'importe_bases'){
                        var importe_base_csv = alb[1];
                    }else if(alb[0] == 'importe_totales'){
                       //nada
                    }else{
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        albaranesPDF.push(alb[1]);
                    }
                }
                if(resp.errores){
                    erroresPDF = resp.errores;
                    for(let errors of erroresPDF){
                        
                        var newerror = errors.error.replaceAll('\\u20ac' , '€');
                        errors.error = newerror;
                    }
                }
            }catch(e){
                console.log('Error:', e);
            }finally{
                var grupoaux = [];                
                for(let albaran of albaranesPDF){
                    var aux = {};
                    aux['Nº Albarán'] = albaran.numero;
                    aux['Fecha Albarán'] = albaran.fecha;
                    aux['Expediente'] = albaran.expediente;
                    aux['Cliente'] = albaran.cliente;
                    aux['Importe'] = albaran.importe_base;
                    aux['Error']='';
                    grupoaux.push(aux);
                }
                for(let error of erroresPDF){
                    var auxerr = {};
                    auxerr['Nº Albarán'] = '';
                    auxerr['Fecha Albarán'] = '';
                    auxerr['Expediente'] = '';
                    auxerr['Cliente'] = '';
                    auxerr['Importe'] = '';
                    auxerr['Error']=error.error;
                    grupoaux.push(auxerr);
                }
                var auxtotal={'Nº Albarán': 'Total', 'Fecha Albarán': '', 'Expediente': '', 'Cliente': '', 'Importe':importe_base_csv};
                grupoaux.push(auxtotal);
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: Object.values(grupoaux), filename: 'Descarga_facturas_' + fechahoy ,delimiter:";"});  
            }
        },    
        async mostrarAlbaranesNumerosExpe(){
            this.spinner = true;
            var companias = [];
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    companias.push(compa.id);
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    companias.push(compa.id);
                }
            }
            this.albaranes = [];
            const api = new PwgsApi();
            var body = {id_empresa:this.empresaselec, ids_companias:companias, fecha_inicio:this.fechaesp(this.fecha_inicio), fecha_fin:this.fechaesp(this.fecha_fin)};
            if(this.numerosExpedientes){
                body.expedientes = this.numerosExpedientes.split(";");
            }
            if(this.incluirelacionados){
                body.incluir_relacionados = 1;
            }
            try{
                const resp = await api.post('facturacion-albaranes/expedientes', body);
                for(let alb of Object.entries(resp)){
                    if(alb[0] == 'importe_totales'){
                        this.importe_total = alb[1];
                    }else if(alb[0] == 'importe_bases'){
                        this.importe_base = alb[1];
                    }else{
                        if(alb[1].fecha){
                            alb[1].fecha= this.transformarFecha(alb[1].fecha);
                        }
                        this.albaranes.push(alb[1]);
                    }
                }
            }catch(e){
                console.error('Error:', e);
                this.spinner = false;
            }finally{
                this.albaranesMarcados = [];
                this.facturaGenerada = false;
                this.urlFacturaCreada = '';
                this.obtenerDatosFactura();
                this.albaranesVisibles = false;
                this.albaranesCSVVisibles = false;
                this.albaranesCSVLDVisibles = false;
                this.albaranesVisibles = true;
                this.spinner = false;
            }
        },
        async exportarCSVAlbaranesNumerosExpe(){
            var companias = [];
            var albaranes = [];
            if(this.companiasSeleccionadas.length==0){
                for(let compa of this.companias){
                    companias.push(compa.id);
                }
            }else{
                for(let compa of this.companiasSeleccionadas){
                    companias.push(compa.id);
                }
            }
            this.albaranes = [];
            const api = new PwgsApi();
            var body = {id_empresa:this.empresaselec, ids_companias:companias, fecha_inicio:this.fechaesp(this.fecha_inicio), fecha_fin:this.fechaesp(this.fecha_fin)};
            if(this.numerosExpedientes){
                body.expedientes = this.numerosExpedientes.split(";");
            }
            if(this.incluirelacionados){
                body.incluir_relacionados = 1;
            }
            try{
                const resp = await api.post('facturacion-albaranes/expedientes', body);
                for(let alb of Object.entries(resp)){
                    if (alb[0] == 'importe_totales') {
                        //nada  
                    }else if(alb[0] == 'importe_bases'){
                        var importe_base = parseFloat(alb[1]).toFixed(2);
                    }else{
                        if(alb[1].factura){
                            alb[1].marcada = false;
                        }
                        albaranes.push(alb[1]);
                    }
                }
            }catch(e){
                console.error(e);
            }finally{               
                var grupoaux = [];                
                for(let albaran of albaranes){
                    var aux = {};
                    aux['Nº Albarán'] = albaran.numero;
                    aux['Fecha Albarán'] = albaran.fecha;
                    aux['Expediente'] = albaran.expediente;
                    aux['Cliente'] = albaran.cliente;
                    aux['Importe'] = albaran.importe_base;
                    grupoaux.push(aux);
                }
                var auxtotal={'Nº Albarán': 'Total', 'Fecha Albarán': '', 'Expediente': '', 'Cliente': '', 'Importe':importe_base};
                grupoaux.push(auxtotal);
                let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
                jsonToCsvExport({ data: Object.values(grupoaux), filename: 'Descarga_facturas_' + fechahoy, delimiter: ";" });  
            }
        },
        comprobarPestañas(){
            this.mostrarCSV=false;
            this.mostrarCSVLD=false;
            this.mostrarPDF=false;
            this.series = [];
            this.incluiravisoscsv=false;
            this.incluiravisoscsvld=false;
            this.incluirelacionados = false;
            this.mostraravisos=false;
            this.mostrarrelacionados=false;
            this.serieCSVLDseleccionada = '';
            this.serieCSVseleccionada='';
            $('.nav-link').removeClass('active');
            $(`[href="#busqueda"]`).addClass('active');
            $('.tab-pane').removeClass('active');
            $(`#busqueda`).addClass('active');
            if(this.companiasSeleccionadas.length > 0){
                var numero = this.companiasSeleccionadas.length;
                var csv = 0;
                var csVLD = 0;
                var pdf = 0;
                var avisos = 0;
                var relacionados = 0;
                for(let compa of this.companiasSeleccionadas){
                    if(compa.incluir_avisos=='1'){
                        avisos++;
                    }
                    if(compa.incluir_relacionados=='1'){
                        relacionados++;
                    }
                    if(compa.tipos_importacion_disponibles.includes('importacion-csv')){
                        csv++;
                    }
                    if(compa.tipos_importacion_disponibles.includes('importacion-csv-ld')){
                        csVLD++;
                    }
                    if(compa.tipos_importacion_disponibles.includes('importacion-pdf')){
                        pdf++;
                    }
                    for(let linea of compa.lineas_facturacion){
                        this.series.push(linea);
                    }
                }
                if(avisos == numero){
                    this.mostraravisos = true;
                }
                if(relacionados == numero){
                    this.mostrarrelacionados = true;
                }
                if(csv == numero){
                    this.mostrarCSV = true;
                }
                if(csVLD == numero){
                    this.mostrarCSVLD = true;
                }
                if(pdf == numero){
                    this.mostrarPDF = true;
                }
            }
        },
        async obtenerDatos(){
            const api = new PwgsApi();            
            this.empresas = await api.get('empresas/todas');
            this.empresaselec = this.empresas[0].id;
        },
        async obtenerCompanias(){
            const api = new PwgsApi();
            const resp = await api.get('facturacion-albaranes/companias/'+this.empresaselec);
            this.companias = resp.datos;
            this.companiasCargadas = true;
        },
        fechaActual() {
            const hoy = new Date();
            this.fecha_fin = this.fechaing(hoy.toLocaleDateString());
            hoy.setMonth(hoy.getMonth() - 1);
            this.fecha_inicio = this.fechaing(hoy.toLocaleDateString());
            this.añoActual();
        },
        añoActual() {
            var hoy = new Date();
            this.dia_actual = hoy.toLocaleDateString();
            this.año_actual = new Date().getFullYear();
            this.añosFacturas.push(this.año_actual);
            this.añosFacturas.push(this.año_actual-1);
            this.añosFacturas.push(this.año_actual-2);
            this.añosCSVFacturas.push(this.año_actual);
            this.añosCSVFacturas.push(this.año_actual-1);
            this.añosCSVFacturas.push(this.año_actual-2);
            this.añosCSVFiscal.push(this.año_actual);
            this.añosCSVFiscal.push(this.año_actual-1);
            this.añosCSVLDFacturas.push(this.año_actual);
            this.añosCSVLDFacturas.push(this.año_actual-1);
            this.añosCSVLDFacturas.push(this.año_actual-2);
            this.añosCSVLDFiscal.push(this.año_actual);
            this.añosCSVLDFiscal.push(this.año_actual-1);
            this.añosPDFFacturas.push(this.año_actual-2);
            this.añosPDFFacturas.push(this.año_actual);
            this.añosPDFFacturas.push(this.año_actual-1);
            this.añosPDFFacturas.push(this.año_actual-2);
            this.añoFactura = this.año_actual;
            this.añoCSVFactura = this.año_actual; 
            this.añoCSVFiscal = this.año_actual; 
            this.añoCSVLDFiscal = this.año_actual; 
            this.añoCSVLDFactura = this.año_actual;
            this.añoPDFFactura = this.año_actual;       
        },
        fechaing(fecha) {
        const [dia, mes, año] = fecha.split("/");
        return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        },

        fechaesp(fecha) {
        const [año, mes, dia] = fecha.split("-");
        return `${dia}/${mes}/${año}`;
        },
        async cargarImpuestos(){
            const api = new PwgsApi();
            const ress = await api.get('impuestos');
            this.impuestos = ress.datos;
        }
    },
    mounted(){
        this.obtenerDatos();
        this.fechaActual();
        this.cargarImpuestos();
    },
    watch:{
        destinatarioFactura(){
            this.obtenerDatosFactura();
        },
        empresaFactura(){
            this.obtenerDatosFactura();
        },
        serieFactura(){
            this.obtenerNumero();
        },
        añoFactura(){
            this.obtenerDatosFactura();
        },
        destinatarioCSVFactura(){
            this.obtenerDatosFacturaCSV();
        },
        empresaCSVFactura(){
            this.obtenerDatosFacturaCSV();
        },
        serieCSVFactura(){
            this.obtenerNumeroCSV();
        },
        añoCSVFactura(){
            this.obtenerDatosFacturaCSV();
        },
        destinatarioCSVLDFactura(){
            this.obtenerDatosFacturaCSVLD();
        },
        empresaCSVLDFactura(){
            this.obtenerDatosFacturaCSVLD();
        },
        serieCSVLDFactura(){
            this.obtenerNumeroCSVLD();
        },
        añoCSVLDFactura(){
            this.obtenerDatosFacturaCSVLD();
        },
        destinatarioPDFFactura(){
            this.obtenerDatosFacturaPDF();
        },
        empresaPDFFactura(){
            this.obtenerDatosFacturaPDF();
        },
        seriePDFFactura(){
            this.obtenerNumeroPDF();
        },
        añoPDFFactura(){
            this.obtenerDatosFacturaPDF();
        },
        checkTodas(){
            this.marcarTodas();
        },
        checkTodasCSV(){
            this.marcarTodasCSV();
        },
        checkTodasCSVLD(){
            this.marcarTodasCSVLD();
        },
        checkTodasPDF(){
            this.marcarTodasPDF();
        },
        empresaselec(value){
            this.companias = null;
            this.companiasSeleccionadas = [];
            if(value){
                this.obtenerCompanias();
            }
        },
        companiasSeleccionadas(){
            this.comprobarPestañas();
        }
    }
}
</script>
<style >
.difuminado{
        filter: blur(6px);
            pointer-events: none;
            -webkit-user-select: none;
                /* Safari */
            -ms-user-select: none;
                /* IE 10 and IE 11 */
            user-select: none;
                /* Standard syntax */
}
.spinner {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    border: 9px solid;
    border-color: #d9e3ff;
    border-right-color: #007bff;
    animation: spinner-d3wgkg 1s infinite linear;
    position: absolute;
    z-index:1000;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
         
}

@keyframes spinner-d3wgkg {
    to {
        transform: rotate(1turn);
    }
}
</style>